import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path$1l, _path2$3;

function _extends$1m() { _extends$1m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

function SvgAddToList(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
    d: "M4 5h15v2H4zM4 9h15v2H4zM4 17h9v2H4zM4 13h11v2H4zM17 15h2v6h-2z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17h6v2h-6z"
  })));
}

const ForwardRef$1m = /*#__PURE__*/React.forwardRef(SvgAddToList);

var AddToListSolid = forwardRef((props, ref) => jsx(ForwardRef$1m, Object.assign({
  ref: ref
}, props)));

var _path$1k;

function _extends$1l() { _extends$1l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

function SvgAddToPortfolio(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4v8h8a8 8 0 11-8-8zm-1 9h7.93A7 7 0 1111 5.07V13zm3-7.92a6 6 0 011 .26V10h-1V5.08zM16 10V5.8a6 6 0 011 .73V10h1V7.68a6 6 0 01.92 2.32H16zm3.47-1.68A7 7 0 0120 11h-7V4a7 7 0 016.47 4.32z"
  })));
}

const ForwardRef$1l = /*#__PURE__*/React.forwardRef(SvgAddToPortfolio);

var AddToPortfolioOutline = forwardRef((props, ref) => jsx(ForwardRef$1l, Object.assign({
  ref: ref
}, props)));

var _path$1j;

function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

function SvgAngledCollapse(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.474 4.182a1 1 0 0 1 1-1h.12a1 1 0 0 1 1 1v6.485a1 1 0 0 1-1 1H4.11a1 1 0 0 1-1-1v-.121a1 1 0 0 1 1-1h5.364V4.182Zm5.052 15.78a1 1 0 0 1-1 1h-.122a1 1 0 0 1-1-1v-6.486a1 1 0 0 1 1-1h6.486a1 1 0 0 1 1 1v.121a1 1 0 0 1-1 1h-5.364v5.364Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef$1k = /*#__PURE__*/React.forwardRef(SvgAngledCollapse);

var AngledCollapseSolid = forwardRef((props, ref) => jsx(ForwardRef$1k, Object.assign({
  ref: ref
}, props)));

var _path$1i;

function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

function SvgAngledExpand(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.288 13.488a1 1 0 0 1-1 1h-.121a1 1 0 0 1-1-1V7.002a1 1 0 0 1 1-1H13.652a1 1 0 0 1 1 1v.122a1 1 0 0 1-1 1H8.288v5.364Zm7.425-3.303a1 1 0 0 1 1-1h.121a1 1 0 0 1 1 1v6.485a1 1 0 0 1-1 1H10.349a1 1 0 0 1-1-1v-.121a1 1 0 0 1 1-1h5.364v-5.364Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef$1j = /*#__PURE__*/React.forwardRef(SvgAngledExpand);

var AngledExpandSolid = forwardRef((props, ref) => jsx(ForwardRef$1j, Object.assign({
  ref: ref
}, props)));

var _path$1h;

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

function SvgAnnouncement(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6C17.5523 6 18 6.44772 18 7V16C18 16.5523 17.5523 17 17 17C16.4477 17 16 16.5523 16 16V7C16 6.44772 16.4477 6 17 6ZM15.2616 6.01045C15.6059 5.40689 16.2554 5 17 5C18.1046 5 19 5.89543 19 7V16C19 17.1046 18.1046 18 17 18C16.266 18 15.6243 17.6046 15.2764 17.0152L11.3441 15.9264L12.3877 19.0802C12.5376 19.5332 12.2003 20.0001 11.7232 20.0001H9.73987C9.07522 20.0001 8.48982 19.5628 8.30141 18.9254L7.13546 14.9812C5.37377 14.7989 4 13.3099 4 11.5C4 9.567 5.567 8 7.5 8H8.02352L15.2616 6.01045ZM10.1845 15.6053L8.20031 15.0559L9.26038 18.6419C9.32319 18.8543 9.51832 19.0001 9.73987 19.0001H11.3079L10.1845 15.6053ZM9 14.2397L15 15.901V7.11944L9 8.76868V14.2397ZM8 9H7.5C6.11929 9 5 10.1193 5 11.5C5 12.8807 6.11929 14 7.5 14H8V9Z"
  })));
}

const ForwardRef$1i = /*#__PURE__*/React.forwardRef(SvgAnnouncement);

var AnnouncementOutline = forwardRef((props, ref) => jsx(ForwardRef$1i, Object.assign({
  ref: ref
}, props)));

var _path$1g;

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

function SvgArrowRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    d: "M16 12L10 15.4641L10 8.5359L16 12Z"
  })));
}

const ForwardRef$1h = /*#__PURE__*/React.forwardRef(SvgArrowRight);

var ArrowRightSolid = forwardRef((props, ref) => jsx(ForwardRef$1h, Object.assign({
  ref: ref
}, props)));

var _path$1f;

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

function SvgArticle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 3H6v10H3v6a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V3Zm-1 14.5V19a1 1 0 0 1-1 1H6.732A1.99 1.99 0 0 0 7 19V4h12v13.5ZM5 20a1 1 0 0 0 1-1v-5H4v5a1 1 0 0 0 1 1ZM16.807 6.605a.5.5 0 0 1 .088.702l-1.556 2a.5.5 0 0 1-.86-.126l-.101-.258-1.79 1.918a.5.5 0 0 1-.81-.11l-.458-.885-1.462 1.503a.5.5 0 0 1-.716-.697l1.944-2a.5.5 0 0 1 .802.118l.452.871 1.85-1.982a.5.5 0 0 1 .832.16l.069.178 1.014-1.304a.5.5 0 0 1 .702-.088ZM9 13.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef$1g = /*#__PURE__*/React.forwardRef(SvgArticle);

var ArticleOutline = forwardRef((props, ref) => jsx(ForwardRef$1g, Object.assign({
  ref: ref
}, props)));

var _path$1e;

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

function SvgBin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5H14V6H10V5ZM9 6V5C9 4.44772 9.44772 4 10 4H14C14.5523 4 15 4.44772 15 5V6H18C18.5523 6 19 6.44772 19 7V9C19 9.55228 18.5523 10 18 10H17.9091L17.124 18.6358C17.0538 19.4084 16.406 20 15.6302 20H8.36982C7.59402 20 6.94622 19.4084 6.87598 18.6358L6.09091 10H6C5.44772 10 5 9.55228 5 9V7C5 6.44772 5.44772 6 6 6H9ZM15 7H14H10H9H6V9H7.00412H10H11H13H14H16.9959H18V7H15ZM13 10V16.5C13 16.7761 13.2239 17 13.5 17C13.7761 17 14 16.7761 14 16.5V10H16.905L16.1281 18.5453C16.1047 18.8028 15.8888 19 15.6302 19H8.36982C8.11122 19 7.89529 18.8028 7.87188 18.5453L7.09503 10H10V16.5C10 16.7761 10.2239 17 10.5 17C10.7761 17 11 16.7761 11 16.5V10H13Z"
  })));
}

const ForwardRef$1f = /*#__PURE__*/React.forwardRef(SvgBin);

var BinSolid = forwardRef((props, ref) => jsx(ForwardRef$1f, Object.assign({
  ref: ref
}, props)));

var _path$1d;

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

function SvgBoardMembers(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8ZM9.26043 14.0274C9.97275 13.3922 10.9334 13 12.0001 13C13.0671 13 14.0279 13.3924 14.7402 14.0279C14.7349 14.0359 14.7296 14.044 14.7244 14.0521L14.8628 14.142C15.5686 14.8278 16 15.764 16 16.7857L16 18H12.2097H8.00001L8.00008 17.1633L8.00011 17.0188L8.00015 16.7857C8.00015 15.7648 8.4309 14.8293 9.13567 14.1436L9.27659 14.0521L9.26043 14.0274ZM16.0604 13.9912C16.6507 14.7747 17 15.7381 17 16.7857L17 17H22.0009L22.0009 16.5C22.0009 14.567 20.4339 13 18.5009 13C17.5521 13 16.6912 13.3773 16.0604 13.9912ZM17 18L16.9999 18.5C16.9999 18.7762 16.7761 19 16.4999 19H7.50006C7.22395 19 7.0001 18.7762 7.00006 18.5001L7.00001 18H1.5C1.36739 18 1.24021 17.9473 1.14644 17.8535C1.05267 17.7598 0.999992 17.6326 1 17.5L1.00006 16.5C1.00008 14.0147 3.01479 12 5.50006 12C6.71231 12 7.81238 12.4796 8.6211 13.2583C9.5144 12.4751 10.7039 12 12.0001 12C13.2965 12 14.4862 12.4752 15.3795 13.2586C16.1883 12.4797 17.2885 12 18.5009 12C20.9862 12 23.0009 14.0147 23.0009 16.5L23.001 17.5C23.001 17.6326 22.9483 17.7598 22.8545 17.8535C22.7608 17.9473 22.6336 18 22.501 18H17ZM7.94016 13.9908C7.30935 13.3772 6.44867 13 5.50006 13C3.56706 13 2.00006 14.567 2.00006 16.5L2.00003 17H7.00011L7.00015 16.7857C7.00017 15.7379 7.34965 14.7743 7.94016 13.9908ZM5 10C5.55228 10 6 9.55228 6 9C6 8.44772 5.55228 8 5 8C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10ZM5 11C6.10457 11 7 10.1046 7 9C7 7.89543 6.10457 7 5 7C3.89543 7 3 7.89543 3 9C3 10.1046 3.89543 11 5 11ZM19 10C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8C18.4477 8 18 8.44772 18 9C18 9.55228 18.4477 10 19 10ZM19 11C20.1046 11 21 10.1046 21 9C21 7.89543 20.1046 7 19 7C17.8954 7 17 7.89543 17 9C17 10.1046 17.8954 11 19 11Z"
  })));
}

const ForwardRef$1e = /*#__PURE__*/React.forwardRef(SvgBoardMembers);

var BoardMembersOutline = forwardRef((props, ref) => jsx(ForwardRef$1e, Object.assign({
  ref: ref
}, props)));

var _path$1c;

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

function SvgBoldText(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    d: "M13.4813 17.25H8V6H13.0125C13.6389 6.00004 14.2521 6.17935 14.7798 6.51674C15.3075 6.85414 15.7276 7.33552 15.9905 7.90403C16.2534 8.47254 16.3481 9.10442 16.2634 9.72501C16.1787 10.3456 15.9181 10.929 15.5125 11.4062C16.0423 11.83 16.4278 12.4075 16.6158 13.0594C16.8039 13.7112 16.7852 14.4053 16.5625 15.0461C16.3397 15.6869 15.9238 16.2429 15.372 16.6376C14.8202 17.0323 14.1597 17.2463 13.4813 17.25ZM10.0083 15.375H13.4688C13.6534 15.375 13.8363 15.3386 14.0069 15.268C14.1775 15.1973 14.3325 15.0937 14.4631 14.9631C14.5937 14.8325 14.6973 14.6775 14.768 14.5069C14.8386 14.3363 14.875 14.1534 14.875 13.9688C14.875 13.7841 14.8386 13.6012 14.768 13.4306C14.6973 13.26 14.5937 13.105 14.4631 12.9744C14.3325 12.8438 14.1775 12.7402 14.0069 12.6695C13.8363 12.5989 13.6534 12.5625 13.4688 12.5625H10.0083V15.375ZM10.0083 10.6875H13.0125C13.1972 10.6875 13.38 10.6511 13.5507 10.5805C13.7213 10.5098 13.8763 10.4062 14.0069 10.2756C14.1375 10.145 14.241 9.99001 14.3117 9.8194C14.3824 9.64878 14.4188 9.46592 14.4188 9.28125C14.4188 9.09658 14.3824 8.91372 14.3117 8.7431C14.241 8.57249 14.1375 8.41746 14.0069 8.28688C13.8763 8.1563 13.7213 8.05272 13.5507 7.98204C13.38 7.91137 13.1972 7.875 13.0125 7.875H10.0083V10.6875Z"
  })));
}

const ForwardRef$1d = /*#__PURE__*/React.forwardRef(SvgBoldText);

var BoldTextSolid = forwardRef((props, ref) => jsx(ForwardRef$1d, Object.assign({
  ref: ref
}, props)));

var _path$1b, _path2$2, _path3, _path4, _path5, _path6;

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

function SvgBulletList(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 7.55228 5.55228 8 5 8C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6C5.55228 6 6 6.44772 6 7Z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16C5.55228 16 6 16.4477 6 17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H19C19.5523 8 20 7.55228 20 7C20 6.44772 19.5523 6 19 6H9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 11.4477 8.44772 11 9 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H9C8.44772 13 8 12.5523 8 12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17C8 16.4477 8.44772 16 9 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H9C8.44772 18 8 17.5523 8 17Z"
  })));
}

const ForwardRef$1c = /*#__PURE__*/React.forwardRef(SvgBulletList);

var BulletListSolid = forwardRef((props, ref) => jsx(ForwardRef$1c, Object.assign({
  ref: ref
}, props)));

var _path$1a;

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

function SvgCalendar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V5H16V4.5C16 4.22386 16.2239 4 16.5 4C16.7761 4 17 4.22386 17 4.5V5H18C19.1046 5 20 5.89543 20 7V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V7C4 5.89543 4.89543 5 6 5H7V4.5ZM16 6V7.5C16 7.77614 16.2239 8 16.5 8C16.7761 8 17 7.77614 17 7.5V6H18C18.5523 6 19 6.44772 19 7V17C19 17.5523 18.5523 18 18 18H6C5.44772 18 5 17.5523 5 17V7C5 6.44772 5.44772 6 6 6H7V7.5C7 7.77614 7.22386 8 7.5 8C7.77614 8 8 7.77614 8 7.5V6H16ZM7 10V11H9V10H7ZM7 9C6.44772 9 6 9.44772 6 10V11C6 11.5523 6.44772 12 7 12H9C9.55228 12 10 11.5523 10 11V10C10 9.44772 9.55228 9 9 9H7ZM12 10H13V11H12V10ZM11 10C11 9.44772 11.4477 9 12 9H13C13.5523 9 14 9.44772 14 10V11C14 11.5523 13.5523 12 13 12H12C11.4477 12 11 11.5523 11 11V10ZM17 11V10H16V11H17ZM16 9C15.4477 9 15 9.44772 15 10V11C15 11.5523 15.4477 12 16 12H17C17.5523 12 18 11.5523 18 11V10C18 9.44772 17.5523 9 17 9H16ZM9 14V15H7V14H9ZM6 14C6 13.4477 6.44772 13 7 13H9C9.55228 13 10 13.4477 10 14V15C10 15.5523 9.55228 16 9 16H7C6.44772 16 6 15.5523 6 15V14ZM13 14H12V15H13V14ZM12 13C11.4477 13 11 13.4477 11 14V15C11 15.5523 11.4477 16 12 16H13C13.5523 16 14 15.5523 14 15V14C14 13.4477 13.5523 13 13 13H12ZM16 15V14H17V15H16ZM15 14C15 13.4477 15.4477 13 16 13H17C17.5523 13 18 13.4477 18 14V15C18 15.5523 17.5523 16 17 16H16C15.4477 16 15 15.5523 15 15V14Z"
  })));
}

const ForwardRef$1b = /*#__PURE__*/React.forwardRef(SvgCalendar);

var CalendarOutline = forwardRef((props, ref) => jsx(ForwardRef$1b, Object.assign({
  ref: ref
}, props)));

var _path$19;

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

function SvgChartStand(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6H6C5.44772 6 5 6.44772 5 7V14C5 14.5523 5.44772 15 6 15H18C18.5523 15 19 14.5523 19 14V7C19 6.44772 18.5523 6 18 6ZM6 5C4.89543 5 4 5.89543 4 7V14C4 15.1046 4.89543 16 6 16H18C19.1046 16 20 15.1046 20 14V7C20 5.89543 19.1046 5 18 5H6ZM3 17.5C3 17.2239 3.22386 17 3.5 17H20.5C20.7761 17 21 17.2239 21 17.5C21 17.7761 20.7761 18 20.5 18H18.1939L18.9745 20.3418C19.0618 20.6038 18.9202 20.8869 18.6582 20.9743C18.3963 21.0616 18.1131 20.92 18.0258 20.658L17.1398 18H6.86049L5.97448 20.658C5.88715 20.92 5.60399 21.0616 5.34202 20.9743C5.08005 20.8869 4.93847 20.6038 5.02579 20.3418L5.80639 18H3.5C3.22386 18 3 17.7761 3 17.5ZM17 8.65292V10C17 10.2761 17.2239 10.5 17.5 10.5C17.7761 10.5 18 10.2761 18 10V7H15C14.7239 7 14.5 7.22386 14.5 7.5C14.5 7.77614 14.7239 8 15 8H16.2288L12.6981 11.149L11.5507 8.28052L9.9381 11.5058L9.07771 10.2152L6.14645 13.1465C5.95118 13.3417 5.95118 13.6583 6.14645 13.8536C6.34171 14.0488 6.65829 14.0488 6.85355 13.8536L8.92229 11.7848L10.0619 13.4942L11.4493 10.7195L12.3019 12.851L17 8.65292Z"
  })));
}

const ForwardRef$1a = /*#__PURE__*/React.forwardRef(SvgChartStand);

var ChartStandOutline = forwardRef((props, ref) => jsx(ForwardRef$1a, Object.assign({
  ref: ref
}, props)));

var _path$18;

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

function SvgCheck(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6363 16.3901C10.6409 16.3951 10.6456 16.4001 10.6505 16.4049C10.8457 16.6002 11.1623 16.6002 11.3576 16.4049L18.3816 9.3809C18.5769 9.18563 18.5769 8.86905 18.3816 8.67379C18.1864 8.47853 17.8698 8.47853 17.6745 8.67379L11.0043 15.344L7.29301 11.6327C7.09774 11.4374 6.78116 11.4374 6.5859 11.6327C6.39064 11.8279 6.39064 12.1445 6.5859 12.3398L10.6363 16.3901Z"
  })));
}

const ForwardRef$19 = /*#__PURE__*/React.forwardRef(SvgCheck);

var CheckSolid = forwardRef((props, ref) => jsx(ForwardRef$19, Object.assign({
  ref: ref
}, props)));

var _path$17;

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

function SvgChevronDownSmall(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9497 9.0474C16.5592 8.65688 15.9261 8.65688 15.5355 9.0474L12 12.5829L8.46447 9.0474C8.07394 8.65688 7.44078 8.65688 7.05025 9.0474C6.65973 9.43793 6.65973 10.0711 7.05025 10.4616L11.2929 14.7043C11.6834 15.0948 12.3166 15.0948 12.7071 14.7043L16.9497 10.4616C17.3403 10.0711 17.3403 9.43793 16.9497 9.0474Z"
  })));
}

const ForwardRef$18 = /*#__PURE__*/React.forwardRef(SvgChevronDownSmall);

var ChevronDownSmallSolid = forwardRef((props, ref) => jsx(ForwardRef$18, Object.assign({
  ref: ref
}, props)));

var _path$16;

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

function SvgChevronLeftEnd(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.56641C5.44772 3.56641 5 4.01412 5 4.56641V19.4337C5 19.986 5.44772 20.4337 6 20.4337C6.55228 20.4337 7 19.986 7 19.4337V4.56641C7 4.01412 6.55228 3.56641 6 3.56641ZM17.578 4.24309L10.531 11.2901C10.5229 11.2977 10.5149 11.3055 10.507 11.3134C10.3047 11.5156 10.2072 11.7829 10.2144 12.0479C10.221 12.2949 10.3185 12.5399 10.507 12.7284C10.5147 12.7361 10.5225 12.7436 10.5303 12.751L17.578 19.7987C17.9686 20.1892 18.6017 20.1892 18.9922 19.7987C19.3828 19.4082 19.3828 18.775 18.9922 18.3845L12.6287 12.0209L18.9923 5.6573C19.3828 5.26678 19.3828 4.63361 18.9923 4.24309C18.6017 3.85256 17.9686 3.85256 17.578 4.24309Z"
  })));
}

const ForwardRef$17 = /*#__PURE__*/React.forwardRef(SvgChevronLeftEnd);

var ChevronLeftEndSolid = forwardRef((props, ref) => jsx(ForwardRef$17, Object.assign({
  ref: ref
}, props)));

var _path$15;

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

function SvgChevronLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78127 11.29L14.8283 4.24303C15.2188 3.8525 15.852 3.8525 16.2425 4.24303C16.633 4.63355 16.633 5.26672 16.2425 5.65724L9.87891 12.0208L16.2425 18.3844C16.633 18.7749 16.633 19.4081 16.2425 19.7986C15.852 20.1891 15.2188 20.1891 14.8283 19.7986L7.78057 12.7509C7.7727 12.7435 7.76491 12.736 7.75723 12.7283C7.56873 12.5398 7.47122 12.2948 7.46468 12.0478C7.45748 11.7828 7.55498 11.5156 7.7572 11.3133C7.76513 11.3054 7.77315 11.2977 7.78127 11.29Z"
  })));
}

const ForwardRef$16 = /*#__PURE__*/React.forwardRef(SvgChevronLeft);

var ChevronLeftSolid = forwardRef((props, ref) => jsx(ForwardRef$16, Object.assign({
  ref: ref
}, props)));

var _path$14;

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

function SvgChevronRightEnd(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0042 3.56641C18.5564 3.56641 19.0042 4.01412 19.0042 4.56641V19.4337C19.0042 19.986 18.5564 20.4337 18.0042 20.4337C17.4519 20.4337 17.0042 19.986 17.0042 19.4337V4.56641C17.0042 4.01412 17.4519 3.56641 18.0042 3.56641ZM6.4261 4.24309L13.4731 11.2901C13.4812 11.2977 13.4893 11.3055 13.4972 11.3134C13.6994 11.5156 13.7969 11.7829 13.7897 12.0479C13.7832 12.2949 13.6857 12.5399 13.4972 12.7284C13.4895 12.7361 13.4817 12.7436 13.4738 12.751L6.42612 19.7987C6.0356 20.1892 5.40244 20.1892 5.01191 19.7987C4.62139 19.4082 4.62139 18.775 5.01191 18.3845L11.3755 12.0209L5.01189 5.6573C4.62136 5.26678 4.62136 4.63361 5.01189 4.24309C5.40241 3.85256 6.03558 3.85256 6.4261 4.24309Z"
  })));
}

const ForwardRef$15 = /*#__PURE__*/React.forwardRef(SvgChevronRightEnd);

var ChevronRightEndSolid = forwardRef((props, ref) => jsx(ForwardRef$15, Object.assign({
  ref: ref
}, props)));

var _path$13;

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

function SvgChevronRightSmall(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0474 7.05025C8.65688 7.44078 8.65688 8.07394 9.0474 8.46447L12.5829 12L9.0474 15.5355C8.65688 15.9261 8.65688 16.5592 9.0474 16.9497C9.43793 17.3403 10.0711 17.3403 10.4616 16.9497L14.7043 12.7071C15.0948 12.3166 15.0948 11.6834 14.7043 11.2929L10.4616 7.05025C10.0711 6.65973 9.43793 6.65973 9.0474 7.05025Z"
  })));
}

const ForwardRef$14 = /*#__PURE__*/React.forwardRef(SvgChevronRightSmall);

var ChevronRightSmallSolid = forwardRef((props, ref) => jsx(ForwardRef$14, Object.assign({
  ref: ref
}, props)));

var _path$12;

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

function SvgChevronRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2185 11.2901L9.17146 4.24309C8.78094 3.85256 8.14777 3.85256 7.75725 4.24309C7.36672 4.63361 7.36672 5.26678 7.75725 5.6573L14.1208 12.0209L7.75727 18.3845C7.36675 18.775 7.36675 19.4082 7.75727 19.7987C8.1478 20.1892 8.78096 20.1892 9.17149 19.7987L16.2192 12.751C16.2271 12.7436 16.2348 12.7361 16.2425 12.7284C16.431 12.5399 16.5285 12.2949 16.5351 12.0479C16.5423 11.7829 16.4448 11.5156 16.2426 11.3134C16.2346 11.3055 16.2266 11.2977 16.2185 11.2901Z"
  })));
}

const ForwardRef$13 = /*#__PURE__*/React.forwardRef(SvgChevronRight);

var ChevronRightSolid = forwardRef((props, ref) => jsx(ForwardRef$13, Object.assign({
  ref: ref
}, props)));

var _path$11;

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

function SvgCompany(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9H16V7H8V9ZM16 10H8V12H16V10ZM7 12V13V17V18H8H10H11H13H14H16H17V17V13V12V10V9V7V6H16H8H7V7V9V10V12ZM14 17H16V13H8V17H10V15V14H11H13H14V15V17ZM11 17H13V15H11V17Z"
  })));
}

const ForwardRef$12 = /*#__PURE__*/React.forwardRef(SvgCompany);

var CompanyOutline = forwardRef((props, ref) => jsx(ForwardRef$12, Object.assign({
  ref: ref
}, props)));

var _path$10;

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

function SvgCopyLink(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1V7a2 2 0 0 0-2-2H8V4a1 1 0 0 1 1-1Zm9 16v-1h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v1H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2ZM16 6H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm-8.005 8.591.707-.707a1 1 0 0 1 .966-.259l-.259.26a.5.5 0 1 0 .707.706l.26-.259a1 1 0 0 1-.26.966l-.707.707a1 1 0 1 1-1.414-1.414Zm0-1.414a2.001 2.001 0 0 1 2.43-.309l.443-.443a2.001 2.001 0 0 1 .309-2.43l.707-.707a2 2 0 0 1 2.828 2.828l-.707.707a2.001 2.001 0 0 1-2.43.31l-.443.442c.453.767.35 1.772-.309 2.43l-.707.708a2 2 0 0 1-2.828-2.829l.707-.707Zm4.596-1.06-.259.258a1 1 0 0 0 .966-.259l.707-.707a1 1 0 0 0-1.414-1.414l-.707.707a1 1 0 0 0-.259.966l.259-.259a.5.5 0 1 1 .707.707Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef$11 = /*#__PURE__*/React.forwardRef(SvgCopyLink);

var CopyLinkOutline = forwardRef((props, ref) => jsx(ForwardRef$11, Object.assign({
  ref: ref
}, props)));

var _path$$;

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

function SvgDanger(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.07 4.525c.397-.7 1.463-.7 1.86 0l7.945 14.017c.374.66-.135 1.458-.93 1.458H4.055c-.795 0-1.304-.798-.93-1.458L11.07 4.525ZM12 8c.554 0 1.004.45 1.004 1.003v3.01a1.004 1.004 0 0 1-2.008 0v-3.01C10.996 8.45 11.446 8 12 8Zm0 9.027a1.004 1.004 0 1 0 0-2.007 1.004 1.004 0 0 0 0 2.007Z"
  })));
}

const ForwardRef$10 = /*#__PURE__*/React.forwardRef(SvgDanger);

var DangerSolid = forwardRef((props, ref) => jsx(ForwardRef$10, Object.assign({
  ref: ref
}, props)));

var _path$_;

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

function SvgDiscover$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15.2236L15.4279 14.9251C16.9848 13.8392 18 12.0381 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 12.0381 7.01524 13.8392 8.5721 14.9251L9 15.2236V16H15V15.2236ZM15 17H9C9 17.3689 9.19922 17.6924 9.50073 17.8668L9.73094 18H14.2691L14.4993 17.8668C14.8008 17.6924 15 17.3689 15 17ZM15 18.7324C15.5978 18.3866 16 17.7403 16 17V15.7453C17.8135 14.4804 19 12.3787 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 12.3787 6.18652 14.4804 8 15.7453V17C8 17.7403 8.4022 18.3866 9 18.7324V19V20C9 20.5523 9.44772 21 10 21H14C14.5523 21 15 20.5523 15 20V19V18.7324ZM14 19H10V20H14V19ZM12 6.5C10.067 6.5 8.5 8.067 8.5 10C8.5 10.2761 8.27614 10.5 8 10.5C7.72386 10.5 7.5 10.2761 7.5 10C7.5 7.51472 9.51472 5.5 12 5.5C12.2761 5.5 12.5 5.72386 12.5 6C12.5 6.27614 12.2761 6.5 12 6.5Z"
  })));
}

const ForwardRef$$ = /*#__PURE__*/React.forwardRef(SvgDiscover$1);

var DiscoverOutline = forwardRef((props, ref) => jsx(ForwardRef$$, Object.assign({
  ref: ref
}, props)));

var _path$Z;

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

function SvgDiscover(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.7453C17.8135 14.4804 19 12.3787 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 12.3787 6.18652 14.4804 8 15.7453V16H16V15.7453ZM8.26756 18C8.09739 17.7058 8 17.3643 8 17H16C16 17.3643 15.9026 17.7058 15.7324 18H8.26756ZM9 20V19H15V20C15 20.5523 14.5523 21 14 21H10C9.44772 21 9 20.5523 9 20ZM8.5 10C8.5 8.067 10.067 6.5 12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C9.51472 5.5 7.5 7.51472 7.5 10C7.5 10.2761 7.72386 10.5 8 10.5C8.27614 10.5 8.5 10.2761 8.5 10ZM3.02286 4.81289C2.78371 4.67482 2.47791 4.75676 2.33984 4.9959C2.20177 5.23505 2.28371 5.54084 2.52286 5.67892L4.25491 6.67892C4.49405 6.81699 4.79985 6.73505 4.93792 6.4959C5.07599 6.25676 4.99405 5.95096 4.75491 5.81289L3.02286 4.81289ZM19.0625 6.49639C18.9244 6.25724 19.0064 5.95145 19.2455 5.81338L20.9776 4.81338C21.2167 4.67531 21.5225 4.75724 21.6606 4.99639C21.7986 5.23554 21.7167 5.54133 21.4776 5.6794L19.7455 6.6794C19.5064 6.81747 19.2006 6.73554 19.0625 6.49639ZM1 9.996C1 9.71985 1.22386 9.496 1.5 9.496H3.5C3.77614 9.496 4 9.71985 4 9.996C4 10.2721 3.77614 10.496 3.5 10.496H1.5C1.22386 10.496 1 10.2721 1 9.996ZM20 9.99648C20 9.72034 20.2239 9.49648 20.5 9.49648H22.5C22.7761 9.49648 23 9.72034 23 9.99648C23 10.2726 22.7761 10.4965 22.5 10.4965H20.5C20.2239 10.4965 20 10.2726 20 9.99648ZM2.52286 14.3129C2.28371 14.451 2.20177 14.7568 2.33984 14.9959C2.47791 15.235 2.78371 15.317 3.02286 15.1789L4.75491 14.1789C4.99405 14.0408 5.07599 13.735 4.93792 13.4959C4.79985 13.2568 4.49405 13.1748 4.25491 13.3129L2.52286 14.3129ZM19.0625 13.4964C19.2006 13.2572 19.5064 13.1753 19.7455 13.3134L21.4776 14.3134C21.7167 14.4514 21.7986 14.7572 21.6606 14.9964C21.5225 15.2355 21.2167 15.3175 20.9776 15.1794L19.2455 14.1794C19.0064 14.0413 18.9244 13.7355 19.0625 13.4964Z"
  })));
}

const ForwardRef$_ = /*#__PURE__*/React.forwardRef(SvgDiscover);

var DiscoverSolid = forwardRef((props, ref) => jsx(ForwardRef$_, Object.assign({
  ref: ref
}, props)));

var _path$Y;

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

function SvgDown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46437 14.6716L11.6464 17.8536C11.8416 18.0488 12.1582 18.0488 12.3535 17.8536L15.5354 14.6716C15.7307 14.4763 15.7307 14.1597 15.5354 13.9645C15.3402 13.7692 15.0236 13.7692 14.8283 13.9645L12.4999 16.2929L12.4999 5.5C12.4999 5.22386 12.276 5 11.9999 5C11.7238 5 11.4999 5.22386 11.4999 5.5L11.4999 16.2929L9.17148 13.9645C8.97621 13.7692 8.65963 13.7692 8.46437 13.9645C8.26911 14.1597 8.26911 14.4763 8.46437 14.6716Z"
  })));
}

const ForwardRef$Z = /*#__PURE__*/React.forwardRef(SvgDown);

var DownSolid = forwardRef((props, ref) => jsx(ForwardRef$Z, Object.assign({
  ref: ref
}, props)));

var _path$X;

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

function SvgDownloadImage(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.5C4 4.67157 4.67157 4 5.5 4H18.5C19.3284 4 20 4.67157 20 5.5V13.5C20 14.3284 19.3284 15 18.5 15H17.5C17.2239 15 17 14.7761 17 14.5C17 14.2239 17.2239 14 17.5 14H18.5C18.7761 14 19 13.7761 19 13.5V5.5C19 5.22386 18.7761 5 18.5 5H5.5C5.22386 5 5 5.22386 5 5.5V13.5C5 13.7761 5.22386 14 5.5 14H11.5C11.7761 14 12 14.2239 12 14.5C12 14.7761 11.7761 15 11.5 15H5.5C4.67157 15 4 14.3284 4 13.5V5.5ZM17.87 6.16366C18.0557 6.36799 18.0407 6.68422 17.8363 6.86997L12.3363 11.87L11.9836 12.1907L11.6464 11.8536L9.97385 10.181L6.8254 12.8796C6.61573 13.0593 6.30008 13.0351 6.12037 12.8254C5.94066 12.6157 5.96494 12.3001 6.1746 12.1204L9.6746 9.12037L10.0262 8.81905L10.3536 9.14645L12.0164 10.8093L17.1637 6.13003C17.368 5.94428 17.6842 5.95933 17.87 6.16366ZM14.5 13C14.2239 13 14 13.2239 14 13.5V18.2929L12.3536 16.6464C12.1583 16.4512 11.8417 16.4512 11.6464 16.6464C11.4512 16.8417 11.4512 17.1583 11.6464 17.3536L14.1464 19.8536C14.2402 19.9473 14.3674 20 14.5 20C14.6326 20 14.7598 19.9473 14.8536 19.8536L17.3536 17.3536C17.5488 17.1583 17.5488 16.8417 17.3536 16.6464C17.1583 16.4512 16.8417 16.4512 16.6464 16.6464L15 18.2929V13.5C15 13.2239 14.7761 13 14.5 13ZM7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8C7.55228 8 8 7.55228 8 7C8 6.44772 7.55228 6 7 6Z"
  })));
}

const ForwardRef$Y = /*#__PURE__*/React.forwardRef(SvgDownloadImage);

var DownloadImageSolid = forwardRef((props, ref) => jsx(ForwardRef$Y, Object.assign({
  ref: ref
}, props)));

var _path$W;

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

function SvgDownloadPdf(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 19H18C18.5523 19 19 18.5523 19 18V10H15C14.4477 10 14 9.55229 14 9V5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19ZM15 5.41421L18.5858 9H15V5.41421ZM6 4C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V9.41421C20 9.149 19.8946 8.89464 19.7071 8.70711L15.2929 4.29289C15.1054 4.10536 14.851 4 14.5858 4H6ZM6.95215 15.3718V17H6V12.3789H7.80273C8.14974 12.3789 8.45443 12.4424 8.7168 12.5693C8.98128 12.6963 9.18441 12.8772 9.32617 13.1121C9.46794 13.3448 9.53882 13.6104 9.53882 13.9087C9.53882 14.3615 9.3833 14.7191 9.07227 14.9814C8.76335 15.2417 8.33488 15.3718 7.78687 15.3718H6.95215ZM6.95215 14.6006H7.80273C8.05452 14.6006 8.24601 14.5413 8.3772 14.4229C8.5105 14.3044 8.57715 14.1351 8.57715 13.915C8.57715 13.6886 8.5105 13.5056 8.3772 13.366C8.2439 13.2263 8.05981 13.1544 7.82495 13.1501H6.95215V14.6006ZM10 17V12.3789H11.4219C11.8281 12.3789 12.191 12.4709 12.5105 12.655C12.8321 12.837 13.0828 13.0972 13.2627 13.4358C13.4425 13.7722 13.5325 14.1552 13.5325 14.5847V14.7974C13.5325 15.2269 13.4436 15.6088 13.2659 15.9431C13.0903 16.2774 12.8416 16.5366 12.52 16.7207C12.1984 16.9048 11.8355 16.9979 11.4314 17H10ZM10.9521 13.1501V16.2351H11.4124C11.7847 16.2351 12.0693 16.1134 12.2661 15.8701C12.4629 15.6268 12.5634 15.2787 12.5676 14.8259V14.5815C12.5676 14.1118 12.4703 13.7563 12.2756 13.5151C12.081 13.2718 11.7964 13.1501 11.4219 13.1501H10.9521ZM14.9521 15.1116H16.7803V14.3435H14.9521V13.1501H17.0088V12.3789H14V17H14.9521V15.1116Z"
  })));
}

const ForwardRef$X = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);

var DownloadPdfSolid = forwardRef((props, ref) => jsx(ForwardRef$X, Object.assign({
  ref: ref
}, props)));

var _path$V, _path2$1, _rect$2;

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

function SvgDownloadReport(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 19H7C6.44772 19 6 18.5523 6 18V6C6 5.44772 6.44772 5 7 5H14V8C14 8.55228 14.4477 9 15 9H18V18C18 18.5523 17.5523 19 17 19ZM17.5858 8L15 5.41421V8H17.5858ZM5 6C5 4.89543 5.89543 4 7 4H14.5858C14.851 4 15.1054 4.10536 15.2929 4.29289L18.7071 7.70711C18.8946 7.89464 19 8.149 19 8.41421V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V6Z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C11.7239 8 11.5 8.22386 11.5 8.5V13.2929L9.85355 11.6464C9.65829 11.4512 9.34171 11.4512 9.14645 11.6464C8.95118 11.8417 8.95118 12.1583 9.14645 12.3536L11.6464 14.8536C11.7402 14.9473 11.8674 15 12 15C12.1326 15 12.2598 14.9473 12.3536 14.8536L14.8536 12.3536C15.0488 12.1583 15.0488 11.8417 14.8536 11.6464C14.6583 11.4512 14.3417 11.4512 14.1464 11.6464L12.5 13.2929V8.5C12.5 8.22386 12.2761 8 12 8Z"
  })), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 8,
    height: 1,
    rx: 0.5
  })));
}

const ForwardRef$W = /*#__PURE__*/React.forwardRef(SvgDownloadReport);

var DownloadReportSolid = forwardRef((props, ref) => jsx(ForwardRef$W, Object.assign({
  ref: ref
}, props)));

var _path$U;

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

function SvgDownloadXls(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 19H18C18.5523 19 19 18.5523 19 18V10H15C14.4477 10 14 9.55229 14 9V5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19ZM15 5.41421L18.5858 9H15V5.41421ZM6 4C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V9.41421C20 9.149 19.8946 8.89464 19.7071 8.70711L15.2929 4.29289C15.1054 4.10536 14.851 4 14.5858 4H6ZM15.8542 15.375C15.9812 15.4702 16.0447 15.6077 16.0447 15.7876C16.0447 15.9526 15.9812 16.0817 15.8542 16.1748C15.7273 16.2658 15.5506 16.3113 15.3242 16.3113C14.7148 16.3113 14.4102 16.0563 14.4102 15.5464H13.4548C13.4548 15.8447 13.531 16.1071 13.6833 16.3335C13.8378 16.5599 14.061 16.7387 14.353 16.8699C14.645 16.9989 14.9688 17.0635 15.3242 17.0635C15.8363 17.0635 16.2436 16.9503 16.5461 16.7239C16.8487 16.4954 17 16.1812 17 15.7812C17 15.4215 16.8762 15.1211 16.6287 14.8799C16.3811 14.6387 15.9865 14.4366 15.4448 14.2737C15.1507 14.1848 14.9275 14.0896 14.7751 13.988C14.6249 13.8865 14.5498 13.7606 14.5498 13.6104C14.5498 13.4495 14.6143 13.3205 14.7434 13.2231C14.8725 13.1237 15.0534 13.074 15.2861 13.074C15.5273 13.074 15.7146 13.1332 15.8479 13.2517C15.9812 13.3681 16.0479 13.5321 16.0479 13.7437H17C17 13.4665 16.9281 13.2189 16.7842 13.001C16.6424 12.783 16.4425 12.6148 16.1843 12.4963C15.9262 12.3757 15.6321 12.3154 15.302 12.3154C14.974 12.3154 14.6778 12.3704 14.4133 12.4805C14.151 12.5905 13.9489 12.7439 13.8071 12.9407C13.6675 13.1353 13.5977 13.3575 13.5977 13.6072C13.5977 14.0875 13.86 14.4694 14.3848 14.7529C14.5773 14.8566 14.8386 14.9624 15.1687 15.0703C15.4988 15.1761 15.7273 15.2777 15.8542 15.375ZM7.50366 13.9722L8.37012 12.3789H9.46509L8.11938 14.6704L9.5 17H8.39233L7.50366 15.3813L6.61499 17H5.50732L6.88794 14.6704L5.54224 12.3789H6.63721L7.50366 13.9722ZM11 16.2351H13.0217V17H10.0479V12.3789H11V16.2351Z"
  })));
}

const ForwardRef$V = /*#__PURE__*/React.forwardRef(SvgDownloadXls);

var DownloadXlsSolid = forwardRef((props, ref) => jsx(ForwardRef$V, Object.assign({
  ref: ref
}, props)));

var _path$T;

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

function SvgEdit$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.41406L13.0607 7.3534L15.6464 9.93919L17.5858 7.99985L15 5.41406ZM9.06066 11.3534L12.3536 8.06051L14.9393 10.6463L11.6464 13.9392L9.06066 11.3534ZM8.35355 12.0605L8 12.4141V14.9998L10.5858 14.9999L10.9393 14.6463L8.35355 12.0605ZM7.29289 11.707C7.10536 11.8945 7 12.1488 7 12.4141V14.9998C7 15.5521 7.44772 15.9998 8 15.9998H10.5858C10.851 15.9998 11.1054 15.8945 11.2929 15.707L18.2929 8.70696C18.6834 8.31643 18.6834 7.68327 18.2929 7.29274L15.7071 4.70696C15.3166 4.31643 14.6834 4.31643 14.2929 4.70696L7.29289 11.707Z"
  })));
}

const ForwardRef$U = /*#__PURE__*/React.forwardRef(SvgEdit$1);

var EditOutline = forwardRef((props, ref) => jsx(ForwardRef$U, Object.assign({
  ref: ref
}, props)));

var _path$S;

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

function SvgEdit(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.41406L13.0607 7.3534L15.6464 9.93919L17.5858 7.99985L15 5.41406ZM9.06066 11.3534L12.3536 8.06051L14.9393 10.6463L11.6464 13.9392L9.06066 11.3534ZM8.35355 12.0605L8 12.4141V14.9998L10.5858 14.9999L10.9393 14.6463L8.35355 12.0605ZM7.29289 11.707C7.10536 11.8945 7 12.1488 7 12.4141V14.9998C7 15.5521 7.44772 15.9998 8 15.9998H10.5858C10.851 15.9998 11.1054 15.8945 11.2929 15.707L18.2929 8.70696C18.6834 8.31643 18.6834 7.68327 18.2929 7.29274L15.7071 4.70696C15.3166 4.31643 14.6834 4.31643 14.2929 4.70696L7.29289 11.707ZM4 18.9998H7V19.9998H4V18.9998ZM20 18.9998H9V19.9998H20V18.9998Z"
  })));
}

const ForwardRef$T = /*#__PURE__*/React.forwardRef(SvgEdit);

var EditSolid = forwardRef((props, ref) => jsx(ForwardRef$T, Object.assign({
  ref: ref
}, props)));

var _path$R;

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

function SvgExecutive(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8ZM19 18.2222L19 19H5.00007L5.00009 18.8531L5.0001 18.5L5.00007 18.2798L5 18.2222L5.00007 18.1937C5.0004 18.1289 5.00184 18.0643 5.00438 18C5.0099 17.8602 5.02061 17.7216 5.03634 17.5843C5.39572 14.4475 8.37631 12 12 12C15.7823 12 18.864 14.6665 18.9956 18C18.9982 18.0666 18.9997 18.1334 19 18.2004L19 18.2222ZM12 13C15.3359 13 17.8617 15.3164 17.9945 18H6.0055C6.13832 15.3164 8.66406 13 12 13Z"
  })));
}

const ForwardRef$S = /*#__PURE__*/React.forwardRef(SvgExecutive);

var ExecutiveOutline = forwardRef((props, ref) => jsx(ForwardRef$S, Object.assign({
  ref: ref
}, props)));

var _path$Q;

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

function SvgExecutiveSmall(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM7.16396 17C7.70607 15.3606 9.54672 14 12 14C14.4533 14 16.2939 15.3606 16.836 17H16.8281H16.8047H16.7812H16.7578H16.7344H16.7109H16.6875H16.6641H16.6406H16.6172H16.5938H16.5703H16.5469H16.5234H16.5H16.4766H16.4531H16.4297H16.4062H16.3828H16.3594H16.3359H16.3125H16.2891H16.2656H16.2422H16.2188H16.1953H16.1719H16.1484H16.125H16.1016H16.0781H16.0547H16.0312H16.0078H15.9844H15.9609H15.9375H15.9141H15.8906H15.8672H15.8438H15.8203H15.7969H15.7734H15.75H15.7266H15.7031H15.6797H15.6562H15.6328H15.6094H15.5859H15.5625H15.5391H15.5156H15.4922H15.4688H15.4453H15.4219H15.3984H15.375H15.3516H15.3281H15.3047H15.2812H15.2578H15.2344H15.2109H15.1875H15.1641H15.1406H15.1172H15.0938H15.0703H15.0469H15.0234H15H14.9766H14.9531H14.9297H14.9062H14.8828H14.8594H14.8359H14.8125H14.7891H14.7656H14.7422H14.7188H14.6953H14.6719H14.6484H14.625H14.6016H14.5781H14.5547H14.5312H14.5078H14.4844H14.4609H14.4375H14.4141H14.3906H14.3672H14.3438H14.3203H14.2969H14.2734H14.25H14.2266H14.2031H14.1797H14.1562H14.1328H14.1094H14.0859H14.0625H14.0391H14.0156H13.9922H13.9688H13.9453H13.9219H13.8984H13.875H13.8516H13.8281H13.8047H13.7812H13.7578H13.7344H13.7109H13.6875H13.6641H13.6406H13.6172H13.5938H13.5703H13.5469H13.5234H13.5H13.4766H13.4531H13.4297H13.4062H13.3828H13.3594H13.3359H13.3125H13.2891H13.2656H13.2422H13.2188H13.1953H13.1719H13.1484H13.125H13.1016H13.0781H13.0547H13.0312H13.0078H12.9844H12.9609H12.9375H12.9141H12.8906H12.8672H12.8438H12.8203H12.7969H12.7734H12.75H12.7266H12.7031H12.6797H12.6562H12.6328H12.6094H12.5859H12.5625H12.5391H12.5156H12.4922H12.4688H12.4453H12.4219H12.3984H12.375H12.3516H12.3281H12.3047H12.2812H12.2578H12.2344H12.2109H12.1875H12.1641H12.1406H12.1172H12.0938H12.0703H12.0469H12.0234H12H11.9766H11.9531H11.9297H11.9062H11.8828H11.8594H11.8359H11.8125H11.7891H11.7656H11.7422H11.7188H11.6953H11.6719H11.6484H11.625H11.6016H11.5781H11.5547H11.5312H11.5078H11.4844H11.4609H11.4375H11.4141H11.3906H11.3672H11.3438H11.3203H11.2969H11.2734H11.25H11.2266H11.2031H11.1797H11.1562H11.1328H11.1094H11.0859H11.0625H11.0391H11.0156H10.9922H10.9688H10.9453H10.9219H10.8984H10.875H10.8516H10.8281H10.8047H10.7812H10.7578H10.7344H10.7109H10.6875H10.6641H10.6406H10.6172H10.5938H10.5703H10.5469H10.5234H10.5H10.4766H10.4531H10.4297H10.4062H10.3828H10.3594H10.3359H10.3125H10.2891H10.2656H10.2422H10.2188H10.1953H10.1719H10.1484H10.125H10.1016H10.0781H10.0547H10.0312H10.0078H9.98438H9.96094H9.9375H9.91406H9.89062H9.86719H9.84375H9.82031H9.79688H9.77344H9.75H9.72656H9.70312H9.67969H9.65625H9.63281H9.60938H9.58594H9.5625H9.53906H9.51562H9.49219H9.46875H9.44531H9.42188H9.39844H9.375H9.35156H9.32812H9.30469H9.28125H9.25781H9.23438H9.21094H9.1875H9.16406H9.14062H9.11719H9.09375H9.07031H9.04688H9.02344H9H8.97656H8.95312H8.92969H8.90625H8.88281H8.85938H8.83594H8.8125H8.78906H8.76562H8.74219H8.71875H8.69531H8.67188H8.64844H8.625H8.60156H8.57812H8.55469H8.53125H8.50781H8.48438H8.46094H8.4375H8.41406H8.39062H8.36719H8.34375H8.32031H8.29688H8.27344H8.25H8.22656H8.20312H8.17969H8.15625H8.13281H8.10938H8.08594H8.0625H8.03906H8.01562H7.99219H7.96875H7.94531H7.92188H7.89844H7.875H7.85156H7.82812H7.80469H7.78125H7.75781H7.73438H7.71094H7.6875H7.66406H7.64062H7.61719H7.59375H7.57031H7.54688H7.52344H7.5H7.47656H7.45312H7.42969H7.40625H7.38281H7.35938H7.33594H7.3125H7.28906H7.26562H7.24219H7.21875H7.19531H7.17188H7.16396ZM12 13C14.9027 13 17.3241 14.7178 17.88 17C17.9587 17.3231 18 17.6575 18 18H17H7H6C6 17.6575 6.04132 17.3231 6.12002 17C6.67595 14.7178 9.09725 13 12 13Z"
  })));
}

const ForwardRef$R = /*#__PURE__*/React.forwardRef(SvgExecutiveSmall);

var ExecutiveSmallOutline = forwardRef((props, ref) => jsx(ForwardRef$R, Object.assign({
  ref: ref
}, props)));

var _path$P;

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

function SvgExpand(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.207 10.379a1 1 0 0 1-1.414 0l-.086-.086a1 1 0 0 1 0-1.414l4.5-4.5.086-.086a1 1 0 0 1 1.414 0l.086.086 4.5 4.5a1 1 0 0 1 0 1.414l-.086.086a1 1 0 0 1-1.414 0L12 6.586l-3.793 3.793Zm7.586 2.914a1 1 0 0 1 1.414 0l.086.086a1 1 0 0 1 0 1.414l-4.5 4.5-.086.086a1 1 0 0 1-1.414 0l-.086-.086-4.5-4.5a1 1 0 0 1 0-1.414l.086-.086a1 1 0 0 1 1.414 0L12 17.086l3.793-3.793Z"
  })));
}

const ForwardRef$Q = /*#__PURE__*/React.forwardRef(SvgExpand);

var ExpandSolid = forwardRef((props, ref) => jsx(ForwardRef$Q, Object.assign({
  ref: ref
}, props)));

var _path$O;

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

function SvgEye(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.997 11.994.002.006-.002.006c-.014.056-.09.36-.48.896-.416.573-1.065 1.233-1.92 1.86C16.878 16.02 14.532 17 12 17c-2.533 0-4.879-.98-6.596-2.238-.856-.627-1.505-1.287-1.922-1.86-.39-.535-.465-.84-.479-.896L3.001 12l.002-.006c.014-.056.09-.36.48-.896.416-.573 1.065-1.233 1.92-1.86C7.122 7.98 9.468 7 12 7c2.533 0 4.879.98 6.596 2.238.856.627 1.505 1.287 1.922 1.86.39.535.465.84.479.896ZM23 12c0 2.333-4.925 7-11 7S1 14.333 1 12s4.925-7 11-7 11 4.667 11 7Zm-7 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.333-1.333a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0Z"
  })));
}

const ForwardRef$P = /*#__PURE__*/React.forwardRef(SvgEye);

var EyeSolid = forwardRef((props, ref) => jsx(ForwardRef$P, Object.assign({
  ref: ref
}, props)));

var _path$N;

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

function SvgFilter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7C10 7.55228 9.55228 8 9 8C8.44772 8 8 7.55228 8 7C8 6.44772 8.44772 6 9 6C9.55228 6 10 6.44772 10 7ZM10.7324 8C10.3866 8.5978 9.74028 9 9 9C8.25972 9 7.61337 8.5978 7.26756 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H7C7 5.89543 7.89543 5 9 5C10.1046 5 11 5.89543 11 7H19.5C19.7761 7 20 7.22386 20 7.5C20 7.77614 19.7761 8 19.5 8H10.7324ZM4.5 12C4.22386 12 4 12.2239 4 12.5C4 12.7761 4.22386 13 4.5 13H13.2676C13.6134 13.5978 14.2597 14 15 14C15.7403 14 16.3866 13.5978 16.7324 13H19.5C19.7761 13 20 12.7761 20 12.5C20 12.2239 19.7761 12 19.5 12H17C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12H4.5ZM4.5 17C4.22386 17 4 17.2239 4 17.5C4 17.7761 4.22386 18 4.5 18H7.26756C7.61337 18.5978 8.25972 19 9 19C9.74028 19 10.3866 18.5978 10.7324 18H19.5C19.7761 18 20 17.7761 20 17.5C20 17.2239 19.7761 17 19.5 17H11C11 15.8954 10.1046 15 9 15C7.89543 15 7 15.8954 7 17H4.5ZM15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13ZM10 17C10 17.5523 9.55228 18 9 18C8.44772 18 8 17.5523 8 17C8 16.4477 8.44772 16 9 16C9.55228 16 10 16.4477 10 17Z"
  })));
}

const ForwardRef$O = /*#__PURE__*/React.forwardRef(SvgFilter);

var FilterOutline = forwardRef((props, ref) => jsx(ForwardRef$O, Object.assign({
  ref: ref
}, props)));

var _path$M;

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

function SvgFv$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9H11V10H7V11H10V12H7V15H6V12V11V10V9H7ZM12 9H13.0977L15.4997 13.9657L17.8984 9H19L16 15H15L12 9Z"
  })));
}

const ForwardRef$N = /*#__PURE__*/React.forwardRef(SvgFv$1);

var FvOutline = forwardRef((props, ref) => jsx(ForwardRef$N, Object.assign({
  ref: ref
}, props)));

var _path$L;

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

function SvgFv(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16V8C21 6.89543 20.1046 6 19 6H5ZM11 9H7H6V10V11V12V15H7V12H10V11H7V10H11V9ZM13.0977 9H12L15 15H16L19 9H17.8984L15.4997 13.9657L13.0977 9Z"
  })));
}

const ForwardRef$M = /*#__PURE__*/React.forwardRef(SvgFv);

var FvSolid = forwardRef((props, ref) => jsx(ForwardRef$M, Object.assign({
  ref: ref
}, props)));

var _path$K;

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

function SvgHeadingText(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    d: "M15.4987 11.0192V12.5288H8.45666V11.0192H15.4987ZM8.72475 6V18H7V6H8.72475ZM17 6V18H15.2842V6H17Z"
  })));
}

const ForwardRef$L = /*#__PURE__*/React.forwardRef(SvgHeadingText);

var HeadingTextSolid = forwardRef((props, ref) => jsx(ForwardRef$L, Object.assign({
  ref: ref
}, props)));

var _path$J;

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

function SvgHome$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99989 11.9998V18.9998L10.0006 18.9998V16.0998C10.0006 15.4923 10.4931 14.9998 11.1006 14.9998H12.9006C13.5081 14.9998 14.0006 15.4922 14.0006 16.0998V18.9998H16.9999V11.9998H19.5857L11.9999 4.41406L4.41411 11.9998H6.99989ZM13.0006 19.9998V16.0998C13.0006 16.0445 12.9559 15.9998 12.9006 15.9998H11.1006C11.0454 15.9998 11.0006 16.0445 11.0006 16.0998V19.9998H6.99989C6.44761 19.9998 5.99989 19.5521 5.99989 18.9998V12.9998H4.41411C3.52321 12.9998 3.07704 11.9227 3.70701 11.2927L11.2928 3.70696C11.6833 3.31643 12.3165 3.31643 12.707 3.70696L20.2928 11.2927C20.9228 11.9227 20.4766 12.9998 19.5857 12.9998H17.9999V18.9998C17.9999 19.5521 17.5522 19.9998 16.9999 19.9998H13.0006Z"
  })));
}

const ForwardRef$K = /*#__PURE__*/React.forwardRef(SvgHome$1);

var HomeOutline = forwardRef((props, ref) => jsx(ForwardRef$K, Object.assign({
  ref: ref
}, props)));

var _path$I;

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

function SvgHome(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 3.70696C12.3165 3.31643 11.6833 3.31643 11.2928 3.70696L3.70701 11.2927C3.07704 11.9227 3.52321 12.9998 4.41411 12.9998H5.99989V18.9998C5.99989 19.5521 6.44761 19.9998 6.99989 19.9998H9.99989V16.9998C9.99989 16.4475 10.4476 15.9998 10.9999 15.9998H12.9999C13.5522 15.9998 13.9999 16.4475 13.9999 16.9998V19.9998H16.9999C17.5522 19.9998 17.9999 19.5521 17.9999 18.9998V12.9998H19.5857C20.4766 12.9998 20.9228 11.9227 20.2928 11.2927L12.707 3.70696Z"
  })));
}

const ForwardRef$J = /*#__PURE__*/React.forwardRef(SvgHome);

var HomeSolid = forwardRef((props, ref) => jsx(ForwardRef$J, Object.assign({
  ref: ref
}, props)));

var _path$H;

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

function SvgInfoDescription(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99989 7.5C6.99989 6.67157 7.67146 6 8.49989 6C9.32832 6 9.99989 6.67157 9.99989 7.5C9.99989 8.32843 9.32832 9 8.49989 9C7.67146 9 6.99989 8.32843 6.99989 7.5ZM11.4999 7C11.2237 7 10.9999 7.22386 10.9999 7.5C10.9999 7.77614 11.2237 8 11.4999 8H17.4999C17.776 8 17.9999 7.77614 17.9999 7.5C17.9999 7.22386 17.776 7 17.4999 7H11.4999ZM10.9999 10.5C10.9999 10.2239 11.2237 10 11.4999 10H18.4999C18.776 10 18.9999 10.2239 18.9999 10.5C18.9999 10.7761 18.776 11 18.4999 11H11.4999C11.2237 11 10.9999 10.7761 10.9999 10.5ZM11.4999 13C11.2237 13 10.9999 13.2239 10.9999 13.5C10.9999 13.7761 11.2237 14 11.4999 14H17.4999C17.776 14 17.9999 13.7761 17.9999 13.5C17.9999 13.2239 17.776 13 17.4999 13H11.4999ZM11.4999 16C11.2237 16 10.9999 16.2239 10.9999 16.5C10.9999 16.7761 11.2237 17 11.4999 17H18.4999C18.776 17 18.9999 16.7761 18.9999 16.5C18.9999 16.2239 18.776 16 18.4999 16H11.4999ZM8.44711 10.7236C8.55678 10.5043 8.49118 10.2378 8.29224 10.0944C8.0933 9.95099 7.81973 9.97305 7.64633 10.1465C7.4745 10.3183 6.21623 11.5675 4.84178 12.0257C4.57981 12.113 4.43823 12.3961 4.52555 12.6581C4.61287 12.9201 4.89603 13.0617 5.15801 12.9743C5.70302 12.7927 6.22363 12.5126 6.68102 12.2144C6.39241 12.9453 6.18075 13.6088 6.04281 14.1946C5.91706 14.7286 5.8499 15.2091 5.84572 15.6241C5.84161 16.0324 5.89799 16.4142 6.05269 16.7236C6.28816 17.1945 6.65284 17.4888 7.10595 17.5721C7.52959 17.6499 7.95069 17.5282 8.30204 17.3513C8.99851 17.0008 9.64944 16.3189 9.9471 15.7236C10.0706 15.4766 9.97048 15.1763 9.72349 15.0528C9.4765 14.9293 9.17617 15.0294 9.05267 15.2764C8.85034 15.6811 8.35443 16.2055 7.85249 16.4581C7.60462 16.5828 7.41362 16.6118 7.28668 16.5885C7.18919 16.5706 7.0648 16.5117 6.94711 16.2764C6.89127 16.1647 6.84238 15.961 6.84567 15.6341C6.84889 15.3139 6.9018 14.9096 7.01619 14.4238C7.24489 13.4526 7.70866 12.2005 8.44711 10.7236Z"
  })));
}

const ForwardRef$I = /*#__PURE__*/React.forwardRef(SvgInfoDescription);

var InfoDescriptionSolid = forwardRef((props, ref) => jsx(ForwardRef$I, Object.assign({
  ref: ref
}, props)));

var _path$G;

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

function SvgInformation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM13 8V10H11V8H13ZM13 16V11H11V16H13Z"
  })));
}

const ForwardRef$H = /*#__PURE__*/React.forwardRef(SvgInformation);

var InformationSolid = forwardRef((props, ref) => jsx(ForwardRef$H, Object.assign({
  ref: ref
}, props)));

var _path$F;

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

function SvgItalicText(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7.25V6H9.125V7.25H12.3375L9.60625 16H6V17.25H14.125V16H10.9125L13.6437 7.25H17.25Z"
  })));
}

const ForwardRef$G = /*#__PURE__*/React.forwardRef(SvgItalicText);

var ItalicTextSolid = forwardRef((props, ref) => jsx(ForwardRef$G, Object.assign({
  ref: ref
}, props)));

var _path$E;

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

function SvgLineDown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.096 6.706a.5.5 0 0 1 .698-.11l5.192 3.775 2.202-1.761.306-.245.31.239 6.5 5a.5.5 0 0 1-.609.792l-6.189-4.76-2.194 1.755-.298.238-.308-.225-5.5-4a.5.5 0 0 1-.11-.698ZM19.5 11a.5.5 0 0 1 .5.5V16h-4.5a.5.5 0 1 1 0-1H19v-3.5a.5.5 0 0 1 .5-.5Z"
  })));
}

const ForwardRef$F = /*#__PURE__*/React.forwardRef(SvgLineDown);

var LineDownOutline = forwardRef((props, ref) => jsx(ForwardRef$F, Object.assign({
  ref: ref
}, props)));

var _path$D;

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

function SvgLineUp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6.5a.5.5 0 0 1 .5-.5H20v4.5a.5.5 0 0 1-1 0V7h-3.5a.5.5 0 0 1-.5-.5Zm3.376 1.17a.5.5 0 0 1-.047.706L9.936 15.72l-1.997-2.496-4.107 3.65a.5.5 0 1 1-.664-.748l4.893-4.35 2.003 2.504 7.607-6.656a.5.5 0 0 1 .705.047Z"
  })));
}

const ForwardRef$E = /*#__PURE__*/React.forwardRef(SvgLineUp);

var LineUpOutline = forwardRef((props, ref) => jsx(ForwardRef$E, Object.assign({
  ref: ref
}, props)));

var _path$C;

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

function SvgLink(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.702 12.884-.707.707a1 1 0 0 0 1.414 1.414l.707-.707a1 1 0 0 0 .26-.966l-.26.259a.5.5 0 1 1-.707-.707l.259-.259a1 1 0 0 0-.966.259Zm1.723-1.016a2.001 2.001 0 0 0-2.43.309l-.707.707a2 2 0 0 0 2.828 2.828l.707-.707a2.001 2.001 0 0 0 .31-2.43l.442-.443c.767.453 1.771.35 2.43-.309l.707-.707a2 2 0 0 0-2.828-2.828l-.707.707a2.001 2.001 0 0 0-.31 2.43l-.442.443Zm1.907-.493.259-.259a.5.5 0 1 0-.707-.707l-.259.259a1 1 0 0 1 .259-.966l.707-.707a1 1 0 0 1 1.414 1.414l-.707.707a1 1 0 0 1-.966.26Z"
  })));
}

const ForwardRef$D = /*#__PURE__*/React.forwardRef(SvgLink);

var LinkOutline = forwardRef((props, ref) => jsx(ForwardRef$D, Object.assign({
  ref: ref
}, props)));

var _path$B;

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

function SvgList(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4V5H20V4ZM20 7H4V8H20V7ZM4 10H20V11H4V10ZM20 13H4V14H20V13ZM4 16H20V17H4V16ZM20 19H4V20H20V19Z"
  })));
}

const ForwardRef$C = /*#__PURE__*/React.forwardRef(SvgList);

var ListSolid = forwardRef((props, ref) => jsx(ForwardRef$C, Object.assign({
  ref: ref
}, props)));

var _path$A;

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

function SvgMarketInsights(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3H4v1h-.5a1.5 1.5 0 1 0 0 3H4v1H2v1h2v1h1V9h.5a1.5 1.5 0 1 0 0-3H5V5h2V4H5V3ZM4 5h-.5a.5.5 0 0 0 0 1H4V5Zm1 2v1h.5a.5.5 0 0 0 0-1H5Zm7-2c-.366 0-.725.028-1.075.082.338.48.477 1.025.451 1.574-.039.829-.45 1.626-1.022 2.198-.39.389-.492.76-.614 1.37l-.026.134c-.12.604-.271 1.374-.767 2.366-.455.911-1.204 1.557-1.926 1.992-.416.25-.834.438-1.203.57A7 7 0 0 0 11.934 19c-.018-.1-.04-.213-.065-.339-.087-.428-.21-.962-.354-1.54-.231-.924-.574-1.497-.877-1.98l-.06-.096c-.275-.438-.578-.919-.578-1.545 0-.577.145-1.226.646-1.728C11.148 11.27 11.923 11 13 11c1.19 0 2.435.728 3.416 1.71a7.999 7.999 0 0 1 1.748 2.61c.533-.987.836-2.118.836-3.32v-.02c-.566-.047-1.019-.183-1.436-.42-.496-.284-.912-.7-1.385-1.174l-.033-.032a.8.8 0 0 0-.52-.232 2.772 2.772 0 0 0-.37-.009l-.13.005c-.1.003-.212.007-.313.007-.307 0-.702-.03-1.058-.276-.363-.25-.599-.661-.74-1.228-.25-1 .125-1.869.64-2.48.233-.276.506-.515.787-.703A6.985 6.985 0 0 0 12 5Zm-2.53.471c.116-.045.233-.087.35-.125.432.372.579.819.558 1.262-.026.54-.304 1.11-.732 1.539-.61.61-.758 1.239-.886 1.88l-.027.132c-.117.593-.246 1.25-.68 2.118-.345.688-.93 1.21-1.549 1.582-.384.232-.77.4-1.093.51A6.988 6.988 0 0 1 5 12H4a8 8 0 1 0 5.108-7.461l.362.932Zm7.99 10.91a6.992 6.992 0 0 1-4.522 2.557 14.21 14.21 0 0 0-.089-.475 37.43 37.43 0 0 0-.364-1.584c-.269-1.075-.676-1.753-.998-2.269-.336-.536-.487-.782-.487-1.11 0-.423.105-.773.354-1.021.248-.248.723-.479 1.646-.479.81 0 1.815.523 2.709 1.416.826.826 1.485 1.9 1.752 2.964ZM15.593 5.99a7.004 7.004 0 0 1 3.331 4.976 2.247 2.247 0 0 1-.863-.276c-.368-.21-.694-.53-1.207-1.044a1.797 1.797 0 0 0-1.12-.519 3.743 3.743 0 0 0-.504-.014l-.165.005a6.772 6.772 0 0 1-.252.006c-.256 0-.393-.032-.49-.099-.09-.062-.23-.214-.338-.647-.15-.6.059-1.148.435-1.594.386-.459.889-.735 1.173-.794Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef$B = /*#__PURE__*/React.forwardRef(SvgMarketInsights);

var MarketInsightsOutline = forwardRef((props, ref) => jsx(ForwardRef$B, Object.assign({
  ref: ref
}, props)));

var _rect$1, _rect2$1, _rect3;

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

function SvgMenu(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    width: 20,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    rx: 1
  })), _rect2$1 || (_rect2$1 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 20,
    height: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 20,
    height: 2,
    rx: 1
  })));
}

const ForwardRef$A = /*#__PURE__*/React.forwardRef(SvgMenu);

var MenuSolid = forwardRef((props, ref) => jsx(ForwardRef$A, Object.assign({
  ref: ref
}, props)));

var _path$z;

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

function SvgMoreHorizontalBold$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13C6.55228 13 7 12.5523 7 12C7 11.4477 6.55228 11 6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13ZM6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM19 12C19 12.5523 18.5523 13 18 13C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11C18.5523 11 19 11.4477 19 12ZM20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12Z"
  })));
}

const ForwardRef$z = /*#__PURE__*/React.forwardRef(SvgMoreHorizontalBold$1);

var MoreHorizontalBoldOutline = forwardRef((props, ref) => jsx(ForwardRef$z, Object.assign({
  ref: ref
}, props)));

var _path$y;

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

function SvgMoreHorizontalBold(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12C16 13.1046 16.8954 14 18 14Z"
  })));
}

const ForwardRef$y = /*#__PURE__*/React.forwardRef(SvgMoreHorizontalBold);

var MoreHorizontalBoldSolid = forwardRef((props, ref) => jsx(ForwardRef$y, Object.assign({
  ref: ref
}, props)));

var _path$x;

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

function SvgMoreHorizontal(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C6 11.4477 6.44772 11 7 11C7.55228 11 8 11.4477 8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12ZM11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12ZM17 11C16.4477 11 16 11.4477 16 12C16 12.5523 16.4477 13 17 13C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11Z"
  })));
}

const ForwardRef$x = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);

var MoreHorizontalSolid = forwardRef((props, ref) => jsx(ForwardRef$x, Object.assign({
  ref: ref
}, props)));

var _path$w;

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

function SvgMoreVertical(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z"
  })));
}

const ForwardRef$w = /*#__PURE__*/React.forwardRef(SvgMoreVertical);

var MoreVerticalSolid = forwardRef((props, ref) => jsx(ForwardRef$w, Object.assign({
  ref: ref
}, props)));

var _path$v;

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

function SvgOpenNewWindow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8A1.5 1.5 0 007 9.5v6A1.5 1.5 0 008.5 17h8a1.5 1.5 0 001.5-1.5V13a.5.5 0 011 0v2.5a2.5 2.5 0 01-2.5 2.5h-8A2.5 2.5 0 016 15.5v-6A2.5 2.5 0 018.5 7H13a.5.5 0 010 1H8.5zm6.5-.5a.5.5 0 01.5-.5H19v3.5a.5.5 0 01-1 0V8.707l-4.646 4.647a.5.5 0 01-.708-.708L17.293 8H15.5a.5.5 0 01-.5-.5z"
  })));
}

const ForwardRef$v = /*#__PURE__*/React.forwardRef(SvgOpenNewWindow);

var OpenNewWindowOutline = forwardRef((props, ref) => jsx(ForwardRef$v, Object.assign({
  ref: ref
}, props)));

var _path$u;

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

function SvgPlus(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5C13 4.44772 12.5523 4 12 4Z"
  })));
}

const ForwardRef$u = /*#__PURE__*/React.forwardRef(SvgPlus);

var PlusSolid = forwardRef((props, ref) => jsx(ForwardRef$u, Object.assign({
  ref: ref
}, props)));

var _path$t;

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

function SvgPortfolio$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.08296C15.5125 5.50448 17.4955 7.4875 17.917 10H13V5.08296ZM19 11C19 10.6605 18.9758 10.3266 18.9291 10C18.4906 6.93431 16.0657 4.5094 13 4.07089C12.6734 4.02417 12.3395 4 12 4V11H19ZM10 12.3966V6.08296C7.16229 6.55904 5 9.027 5 12C5 15.3137 7.68629 18 11 18C12.2313 18 13.3748 17.6299 14.327 16.994L10 12.3966ZM15.0206 17.7309C13.8828 18.5306 12.4962 19 11 19C7.13401 19 4 15.866 4 12C4 8.47353 6.60771 5.55612 10 5.07089C10.3266 5.02417 10.6605 5 11 5V12L15.7976 17.0974L15.7956 17.0992C15.5529 17.3276 15.2939 17.5388 15.0206 17.7309ZM17.0911 15.1769C17.4991 14.5246 17.785 13.7885 17.9172 13H14.9142L17.0911 15.1769ZM17.814 15.8997C17.6261 16.1793 17.4186 16.4445 17.1935 16.6935L12.5 12H19C19 12.3395 18.9758 12.6734 18.9291 13C18.7772 14.0622 18.3868 15.0474 17.814 15.8997Z"
  })));
}

const ForwardRef$t = /*#__PURE__*/React.forwardRef(SvgPortfolio$1);

var PortfolioOutline = forwardRef((props, ref) => jsx(ForwardRef$t, Object.assign({
  ref: ref
}, props)));

var _path$s;

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

function SvgPortfolio(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C15.866 4 19 7.13401 19 11H12V4ZM11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.8567 19 14.5446 18.2771 15.7976 17.0974L11 12V5ZM17.1935 16.6935C18.3162 15.4519 19 13.8058 19 12H12.5L17.1935 16.6935Z"
  })));
}

const ForwardRef$s = /*#__PURE__*/React.forwardRef(SvgPortfolio);

var PortfolioSolid = forwardRef((props, ref) => jsx(ForwardRef$s, Object.assign({
  ref: ref
}, props)));

var _path$r;

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

function SvgQuestionMark(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12a7 7 0 1 0 14 0 7 7 0 0 0-14 0Zm7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-1 11.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm.5-4.5h.546a1 1 0 1 0-.925-1.48 1.421 1.421 0 0 1-.086.14 1.1 1.1 0 0 1-.132.155.583.583 0 0 1-.404.185H9.5c-.276 0-.504-.225-.458-.498a3 3 0 0 1 .324-.939l.018-.031c.036-.065.075-.128.116-.19l.006-.009c.072-.108.152-.212.237-.31L9.763 8A3 3 0 1 1 13 12.828v.672a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5Z"
  })));
}

const ForwardRef$r = /*#__PURE__*/React.forwardRef(SvgQuestionMark);

var QuestionMarkOutline = forwardRef((props, ref) => jsx(ForwardRef$r, Object.assign({
  ref: ref
}, props)));

var _path$q;

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

function SvgReset(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8.46443 8.46455C8.85496 8.07403 9.48812 8.07403 9.87864 8.46455L12 10.5859L14.1214 8.46455C14.5119 8.07403 15.1451 8.07403 15.5356 8.46455C15.9261 8.85508 15.9261 9.48824 15.5356 9.87877L13.4142 12.0001L15.5355 14.1214C15.926 14.5119 15.926 15.1451 15.5355 15.5356C15.145 15.9261 14.5118 15.9261 14.1213 15.5356L12 13.4143L9.87874 15.5356C9.48821 15.9261 8.85505 15.9261 8.46452 15.5356C8.074 15.1451 8.074 14.5119 8.46452 14.1214L10.5858 12.0001L8.46443 9.87877C8.07391 9.48824 8.07391 8.85508 8.46443 8.46455Z"
  })));
}

const ForwardRef$q = /*#__PURE__*/React.forwardRef(SvgReset);

var ResetSolid = forwardRef((props, ref) => jsx(ForwardRef$q, Object.assign({
  ref: ref
}, props)));

var _path$p;

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

function SvgReward(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    d: "M11.0496 5.90475C11.3502 4.98605 12.6498 4.98605 12.9504 5.90475L14.1246 9.49342H17.9049C18.8753 9.49342 19.2769 10.7366 18.49 11.3044L15.4377 13.5066L16.6073 17.0812C16.9083 18.0012 15.8568 18.7695 15.0718 18.2031L12 15.9868L8.92824 18.2031C8.14316 18.7695 7.09168 18.0012 7.39272 17.0812L8.56231 13.5066L5.51002 11.3044C4.72306 10.7366 5.12471 9.49342 6.09512 9.49342H9.87539L11.0496 5.90475Z",
    fillRule: "evenodd"
  })));
}

const ForwardRef$p = /*#__PURE__*/React.forwardRef(SvgReward);

var RewardSolid = forwardRef((props, ref) => jsx(ForwardRef$p, Object.assign({
  ref: ref
}, props)));

var _path$o;

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

function SvgScreener$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C11.7239 2 11.5 2.22386 11.5 2.5V4.01537C7.47999 4.26327 4.26327 7.47999 4.01537 11.5H2.5C2.22386 11.5 2 11.7239 2 12C2 12.2761 2.22386 12.5 2.5 12.5H4.01537C4.26327 16.52 7.47999 19.7367 11.5 19.9846V21.5C11.5 21.7761 11.7239 22 12 22C12.2761 22 12.5 21.7761 12.5 21.5V19.9846C16.52 19.7367 19.7367 16.52 19.9846 12.5H21.5C21.7761 12.5 22 12.2761 22 12C22 11.7239 21.7761 11.5 21.5 11.5H19.9846C19.7367 7.47999 16.52 4.26327 12.5 4.01537V2.5C12.5 2.22386 12.2761 2 12 2ZM18.5 11.5H18.9824C18.7377 8.03251 15.9675 5.2623 12.5 5.01758V5.5C12.5 5.77614 12.2761 6 12 6C11.7239 6 11.5 5.77614 11.5 5.5V5.01758C8.03251 5.2623 5.2623 8.03251 5.01758 11.5H5.5C5.77614 11.5 6 11.7239 6 12C6 12.2761 5.77614 12.5 5.5 12.5H5.01758C5.2623 15.9675 8.03251 18.7377 11.5 18.9824V18.5C11.5 18.2239 11.7239 18 12 18C12.2761 18 12.5 18.2239 12.5 18.5V18.9824C15.9675 18.7377 18.7377 15.9675 18.9824 12.5H18.5C18.2239 12.5 18 12.2761 18 12C18 11.7239 18.2239 11.5 18.5 11.5ZM17.3556 9.35151C17.5497 9.15513 17.5479 8.83855 17.3515 8.64442C17.1551 8.45028 16.8386 8.4521 16.6444 8.64849L13.8841 11.4407L12.943 9.69542L10.5294 13.0526L9.38868 11.4659L6.62143 14.6734C6.44104 14.8825 6.46431 15.1982 6.67339 15.3786C6.88247 15.559 7.1982 15.5357 7.37859 15.3266L9.31722 13.0796L10.5294 14.7656L12.8217 11.5773L13.6453 13.1047L17.3556 9.35151Z"
  })));
}

const ForwardRef$o = /*#__PURE__*/React.forwardRef(SvgScreener$1);

var ScreenerOutline = forwardRef((props, ref) => jsx(ForwardRef$o, Object.assign({
  ref: ref
}, props)));

var _path$n;

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

function SvgScreener(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C11.7239 2 11.5 2.22386 11.5 2.5V4.01537C7.47999 4.26327 4.26327 7.47999 4.01537 11.5H2.5C2.22386 11.5 2 11.7239 2 12C2 12.2761 2.22386 12.5 2.5 12.5H4.01537C4.26327 16.52 7.47999 19.7367 11.5 19.9846V21.5C11.5 21.7761 11.7239 22 12 22C12.2761 22 12.5 21.7761 12.5 21.5V19.9846C16.52 19.7367 19.7367 16.52 19.9846 12.5H21.5C21.7761 12.5 22 12.2761 22 12C22 11.7239 21.7761 11.5 21.5 11.5H19.9846C19.7367 7.47999 16.52 4.26327 12.5 4.01537V2.5C12.5 2.22386 12.2761 2 12 2ZM19.9846 11.5H18.5C18.2239 11.5 18 11.7239 18 12C18 12.2761 18.2239 12.5 18.5 12.5H19.9846C19.9948 12.3346 20 12.1679 20 12C20 11.8321 19.9948 11.6654 19.9846 11.5ZM12.5 19.9846V18.5C12.5 18.2239 12.2761 18 12 18C11.7239 18 11.5 18.2239 11.5 18.5V19.9846C11.6654 19.9948 11.8321 20 12 20C12.1679 20 12.3346 19.9948 12.5 19.9846ZM4.01537 12.5C4.00517 12.3346 4 12.1679 4 12C4 11.8321 4.00517 11.6654 4.01537 11.5H5.5C5.77614 11.5 6 11.7239 6 12C6 12.2761 5.77614 12.5 5.5 12.5H4.01537ZM12.5 4.01537V5.5C12.5 5.77614 12.2761 6 12 6C11.7239 6 11.5 5.77614 11.5 5.5V4.01537C11.6654 4.00517 11.8321 4 12 4C12.1679 4 12.3346 4.00517 12.5 4.01537ZM17.3556 9.35151C17.5497 9.15513 17.5479 8.83855 17.3515 8.64442C17.1551 8.45028 16.8386 8.4521 16.6444 8.64849L13.8841 11.4407L13.3225 10.3991L12.943 9.69542L12.4764 10.3445L10.5294 13.0526L9.75891 11.9809L9.38867 11.4659L8.97436 11.9461L6.62142 14.6734C6.44104 14.8825 6.4643 15.1982 6.67338 15.3786C6.88247 15.559 7.19819 15.5357 7.37858 15.3266L9.31721 13.0796L10.1234 14.201L10.5294 14.7656L10.9354 14.201L12.8217 11.5773L13.3246 12.51L13.6453 13.1047L14.1203 12.6242L17.3556 9.35151Z"
  })));
}

const ForwardRef$n = /*#__PURE__*/React.forwardRef(SvgScreener);

var ScreenerSolid = forwardRef((props, ref) => jsx(ForwardRef$n, Object.assign({
  ref: ref
}, props)));

var _path$m;

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

function SvgSearch(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1923 16.6063C14.0237 17.4816 12.5724 18 11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.5723 17.4816 14.0235 16.6065 15.192L19.706 18.2916C20.0965 18.6821 20.0965 19.3153 19.706 19.7058C19.3155 20.0963 18.6823 20.0963 18.2918 19.7058L15.1923 16.6063ZM16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11Z"
  })));
}

const ForwardRef$m = /*#__PURE__*/React.forwardRef(SvgSearch);

var SearchSolid = forwardRef((props, ref) => jsx(ForwardRef$m, Object.assign({
  ref: ref
}, props)));

var _path$l;

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

function SvgShare(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.646 4.646 8.464 7.828a.5.5 0 0 0 .707.708L11.5 6.207V15a.5.5 0 1 0 1 0V6.207l2.328 2.329a.5.5 0 1 0 .707-.708l-3.182-3.182a.5.5 0 0 0-.707 0ZM5.5 15a.5.5 0 0 0-.5.5V19h14v-3.5a.5.5 0 0 0-1 0V18H6v-2.5a.5.5 0 0 0-.5-.5Z"
  })));
}

const ForwardRef$l = /*#__PURE__*/React.forwardRef(SvgShare);

var ShareOutline = forwardRef((props, ref) => jsx(ForwardRef$l, Object.assign({
  ref: ref
}, props)));

var _path$k;

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

function SvgSidebar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5A1.5 1.5 0 0 0 3 6.5v11A1.5 1.5 0 0 0 4.5 19h8a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 5h-8ZM4 6.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-11ZM17 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3Z"
  })));
}

const ForwardRef$k = /*#__PURE__*/React.forwardRef(SvgSidebar);

var SidebarOutline = forwardRef((props, ref) => jsx(ForwardRef$k, Object.assign({
  ref: ref
}, props)));

var _path$j;

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

function SvgSmileyNeutral(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9ZM14 10C14 9.44772 14.4477 9 15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10ZM8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15H15.5C15.7761 15 16 14.7761 16 14.5C16 14.2239 15.7761 14 15.5 14H8.5Z"
  })));
}

const ForwardRef$j = /*#__PURE__*/React.forwardRef(SvgSmileyNeutral);

var SmileyNeutralSolid = forwardRef((props, ref) => jsx(ForwardRef$j, Object.assign({
  ref: ref
}, props)));

var _path$i;

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

function SvgSorting(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8537 20.3536L20.0357 17.1716C20.2309 16.9763 20.2309 16.6597 20.0357 16.4645C19.8404 16.2692 19.5238 16.2692 19.3286 16.4645L17.0001 18.7929L17.0001 8C17.0001 7.72386 16.7763 7.5 16.5001 7.5C16.224 7.5 16.0001 7.72386 16.0001 8L16.0001 18.7929L13.6717 16.4645C13.4765 16.2692 13.1599 16.2692 12.9646 16.4645C12.7694 16.6597 12.7694 16.9763 12.9646 17.1716L16.1466 20.3536C16.3419 20.5488 16.6584 20.5488 16.8537 20.3536ZM7.14659 3.64645L3.96461 6.82843C3.76935 7.02369 3.76935 7.34027 3.96461 7.53553C4.15988 7.7308 4.47646 7.7308 4.67172 7.53553L7.00015 5.20711L7.00015 16C7.00015 16.2761 7.22401 16.5 7.50015 16.5C7.77629 16.5 8.00015 16.2761 8.00015 16L8.00015 5.20711L10.3286 7.53553C10.5238 7.7308 10.8404 7.7308 11.0357 7.53553C11.2309 7.34027 11.2309 7.02369 11.0357 6.82843L7.8537 3.64645C7.65844 3.45118 7.34186 3.45118 7.14659 3.64645Z"
  })));
}

const ForwardRef$i = /*#__PURE__*/React.forwardRef(SvgSorting);

var SortingOutline = forwardRef((props, ref) => jsx(ForwardRef$i, Object.assign({
  ref: ref
}, props)));

var _path$h;

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

function SvgStatementNegative(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 10L8.70711 6.70711C8.31658 6.31658 7.68342 6.31658 7.29289 6.70711L6.70711 7.29289C6.31658 7.68342 6.31658 8.31658 6.70711 8.70711L10 12L6.70711 15.2929C6.31658 15.6834 6.31658 16.3166 6.70711 16.7071L7.29289 17.2929C7.68342 17.6834 8.31658 17.6834 8.70711 17.2929L12 14L15.2929 17.2929C15.6834 17.6834 16.3166 17.6834 16.7071 17.2929L17.2929 16.7071C17.6834 16.3166 17.6834 15.6834 17.2929 15.2929L14 12L17.2929 8.70711C17.6834 8.31658 17.6834 7.68342 17.2929 7.29289L16.7071 6.70711C16.3166 6.31658 15.6834 6.31658 15.2929 6.70711L12 10Z"
  })));
}

const ForwardRef$h = /*#__PURE__*/React.forwardRef(SvgStatementNegative);

var StatementNegativeSolid = forwardRef((props, ref) => jsx(ForwardRef$h, Object.assign({
  ref: ref
}, props)));

var _path$g;

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function SvgStatementNoData(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.866 3.5L21.5262 18.5C21.9111 19.1667 21.43 20 20.6602 20H3.33968C2.56988 20 2.08875 19.1667 2.47366 18.5L11.1339 3.5C11.5188 2.83334 12.4811 2.83333 12.866 3.5ZM9.40186 2.5C10.5566 0.499999 13.4433 0.500001 14.598 2.5L23.2583 17.5C24.413 19.5 22.9696 22 20.6602 22H3.33968C1.03028 22 -0.413096 19.5 0.741605 17.5L9.40186 2.5ZM10.9999 9C10.9999 8.44772 11.4476 8 11.9999 8C12.5522 8 12.9999 8.44772 12.9999 9V14C12.9999 14.5523 12.5522 15 11.9999 15C11.4476 15 10.9999 14.5523 10.9999 14V9ZM10.9999 17C10.9999 16.4477 11.4476 16 11.9999 16C12.5522 16 12.9999 16.4477 12.9999 17C12.9999 17.5523 12.5522 18 11.9999 18C11.4476 18 10.9999 17.5523 10.9999 17Z"
  })));
}

const ForwardRef$g = /*#__PURE__*/React.forwardRef(SvgStatementNoData);

var StatementNoDataSolid = forwardRef((props, ref) => jsx(ForwardRef$g, Object.assign({
  ref: ref
}, props)));

var _path$f;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function SvgStatementPositive(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM5.70711 13.7071L9.29289 17.2929C9.68342 17.6834 10.3166 17.6834 10.7071 17.2929L18.2929 9.70711C18.6834 9.31658 18.6834 8.68342 18.2929 8.29289L17.7071 7.70711C17.3166 7.31658 16.6834 7.31658 16.2929 7.70711L10 14L7.70711 11.7071C7.31658 11.3166 6.68342 11.3166 6.29289 11.7071L5.70711 12.2929C5.31658 12.6834 5.31658 13.3166 5.70711 13.7071Z"
  })));
}

const ForwardRef$f = /*#__PURE__*/React.forwardRef(SvgStatementPositive);

var StatementPositiveSolid = forwardRef((props, ref) => jsx(ForwardRef$f, Object.assign({
  ref: ref
}, props)));

var _path$e;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function SvgStatementWarning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7ZM11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17Z"
  })));
}

const ForwardRef$e = /*#__PURE__*/React.forwardRef(SvgStatementWarning);

var StatementWarningSolid = forwardRef((props, ref) => jsx(ForwardRef$e, Object.assign({
  ref: ref
}, props)));

var _path$d;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function SvgStocks$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0008 18.9997V7.99985H14.4141L16.9999 5.41406L19.5857 7.99985H18.0008V18.9997H16.0008ZM19.5857 8.99985H19.0008V18.9997C19.0008 19.552 18.553 19.9997 18.0008 19.9997H16.0008C15.4485 19.9997 15.0008 19.552 15.0008 18.9997V8.99985H14.4141C13.5232 8.99985 13.077 7.92271 13.707 7.29274L16.2928 4.70696C16.6833 4.31643 17.3165 4.31643 17.707 4.70696L20.2928 7.29274C20.9228 7.92271 20.4766 8.99985 19.5857 8.99985ZM12 13H10V19H12V13ZM10 12C9.44772 12 9 12.4477 9 13V19C9 19.5523 9.44772 20 10 20H12C12.5523 20 13 19.5523 13 19V13C13 12.4477 12.5523 12 12 12H10ZM6 16H5L5 19H6V16ZM5 15C4.44772 15 4 15.4477 4 16V19C4 19.5523 4.44772 20 5 20H6C6.55228 20 7 19.5523 7 19V16C7 15.4477 6.55228 15 6 15H5Z"
  })));
}

const ForwardRef$d = /*#__PURE__*/React.forwardRef(SvgStocks$1);

var StocksOutline = forwardRef((props, ref) => jsx(ForwardRef$d, Object.assign({
  ref: ref
}, props)));

var _rect, _rect2, _path$c;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function SvgStocks(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 3,
    height: 5,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 4,
    height: 8,
    rx: 1
  })), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.707 4.70696C17.3165 4.31643 16.6833 4.31643 16.2928 4.70696L13.707 7.29274C13.077 7.92271 13.5232 8.99985 14.4141 8.99985H15.0008V18.9997C15.0008 19.552 15.4485 19.9997 16.0008 19.9997H18.0008C18.553 19.9997 19.0008 19.552 19.0008 18.9997V8.99985H19.5857C20.4766 8.99985 20.9228 7.92271 20.2928 7.29274L17.707 4.70696Z"
  })));
}

const ForwardRef$c = /*#__PURE__*/React.forwardRef(SvgStocks);

var StocksSolid = forwardRef((props, ref) => jsx(ForwardRef$c, Object.assign({
  ref: ref
}, props)));

var _path$b;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function SvgSuccess(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-11.707-.707a1 1 0 0 1 1.414 0L11 12.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414Z"
  })));
}

const ForwardRef$b = /*#__PURE__*/React.forwardRef(SvgSuccess);

var SuccessSolid = forwardRef((props, ref) => jsx(ForwardRef$b, Object.assign({
  ref: ref
}, props)));

var _path$a;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgSupport(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17V16H7C5.89543 16 5 15.1046 5 14V7C5 5.89543 5.89543 5 7 5H9.5H11H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H11H9.5H7C5.34315 4 4 5.34315 4 7V14C4 15.6569 5.34315 17 7 17V18L7 19.4981C7 19.9348 7.52042 20.1616 7.84032 19.8644L10.9236 17H16C17.6569 17 19 15.6569 19 14V13.5V12V11.5C19 11.2239 18.7761 11 18.5 11C18.2239 11 18 11.2239 18 11.5V12V13.5V14C18 15.1046 17.1046 16 16 16H10.9236H10.5308L10.243 16.2674L8 18.3511L8 17ZM7 7.5C7 7.22386 7.22386 7 7.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM7.5 10C7.22386 10 7 10.2239 7 10.5C7 10.7761 7.22386 11 7.5 11H8.5C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10H7.5ZM7 13.5C7 13.2239 7.22386 13 7.5 13H8.5C8.77614 13 9 13.2239 9 13.5C9 13.7761 8.77614 14 8.5 14H7.5C7.22386 14 7 13.7761 7 13.5ZM11 12.9991V13H11.0009L11 12.9991ZM13.2565 12.3292L17.9781 7.60751L16.3923 6.02172L11.6708 10.7434L13.2565 12.3292ZM10 11.2071C10 11.0745 10.0527 10.9473 10.1464 10.8536L16.6913 4.30842C17.0819 3.91789 17.715 3.91788 18.1056 4.30841L19.6914 5.8942C20.0819 6.28472 20.0819 6.91787 19.6914 7.3084L13.1464 13.8536C13.0527 13.9473 12.9255 14 12.7929 14H10.5C10.2239 14 10 13.7762 10 13.5V11.2071Z"
  })));
}

const ForwardRef$a = /*#__PURE__*/React.forwardRef(SvgSupport);

var SupportSolid = forwardRef((props, ref) => jsx(ForwardRef$a, Object.assign({
  ref: ref
}, props)));

var _path$9;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgTable(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8V7H18V8H13H12H10H9H6ZM6 9V11H9V9H6ZM6 12V14H9V12H6ZM6 15V17H9V15H6ZM10 17H12V15H10V17ZM13 17H18V15H13V17ZM18 14V12H13V14H18ZM18 11V9H13V11H18ZM5 6.5C5 6.22386 5.22386 6 5.5 6H18.5C18.7761 6 19 6.22386 19 6.5V17.5C19 17.7761 18.7761 18 18.5 18H5.5C5.22386 18 5 17.7761 5 17.5V6.5ZM12 14H10V12H12V14ZM12 9H10V11H12V9Z"
  })));
}

const ForwardRef$9 = /*#__PURE__*/React.forwardRef(SvgTable);

var TableSolid = forwardRef((props, ref) => jsx(ForwardRef$9, Object.assign({
  ref: ref
}, props)));

var _path$8;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgTick(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7629 6.77239C19.3723 6.38186 18.7392 6.38186 18.3487 6.77239L9.58548 15.5356L6.70711 12.6572C6.31658 12.2667 5.68342 12.2667 5.29289 12.6572C4.90237 13.0477 4.90237 13.6809 5.29289 14.0714L8.82843 17.6069C9.03703 17.8155 9.31486 17.9127 9.58797 17.8985C9.85954 17.9113 10.1354 17.8141 10.3428 17.6067L19.7629 8.1866C20.1534 7.79607 20.1534 7.16291 19.7629 6.77239Z"
  })));
}

const ForwardRef$8 = /*#__PURE__*/React.forwardRef(SvgTick);

var TickSolid = forwardRef((props, ref) => jsx(ForwardRef$8, Object.assign({
  ref: ref
}, props)));

var _path$7;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function SvgTiles(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4H4V11H11V4ZM11 13H4V20H11V13ZM13 4H20V11H13V4ZM20 13H13V20H20V13Z"
  })));
}

const ForwardRef$7 = /*#__PURE__*/React.forwardRef(SvgTiles);

var TilesSolid = forwardRef((props, ref) => jsx(ForwardRef$7, Object.assign({
  ref: ref
}, props)));

var _path$6;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function SvgTransfer(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3536 8.1463L15.1716 4.96432C14.9763 4.76906 14.6597 4.76906 14.4645 4.96432C14.2692 5.15958 14.2692 5.47617 14.4645 5.67143L16.7929 7.99986H6.00001C5.72387 7.99986 5.50001 8.22371 5.50001 8.49986C5.50001 8.776 5.72387 8.99986 6.00001 8.99986H16.7929L14.4645 11.3283C14.2692 11.5235 14.2692 11.8401 14.4645 12.0354C14.6597 12.2307 14.9763 12.2307 15.1716 12.0354L18.3536 8.85341C18.5488 8.65815 18.5488 8.34156 18.3536 8.1463ZM5.64645 15.8534L8.82843 19.0354C9.0237 19.2307 9.34028 19.2307 9.53554 19.0354C9.7308 18.8401 9.7308 18.5235 9.53554 18.3283L7.20711 15.9999H18C18.2761 15.9999 18.5 15.776 18.5 15.4999C18.5 15.2237 18.2761 14.9999 18 14.9999H7.20711L9.53554 12.6714C9.7308 12.4762 9.7308 12.1596 9.53554 11.9643C9.34028 11.7691 9.0237 11.7691 8.82843 11.9643L5.64645 15.1463C5.45119 15.3416 5.45119 15.6581 5.64645 15.8534Z"
  })));
}

const ForwardRef$6 = /*#__PURE__*/React.forwardRef(SvgTransfer);

var TransferSolid = forwardRef((props, ref) => jsx(ForwardRef$6, Object.assign({
  ref: ref
}, props)));

var _path$5, _path2;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgUser(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 13C14.2091 13 16 11.2091 16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C8.29547 15 6 17.1169 6 19.5C6 19.7761 5.77614 20 5.5 20C5.22386 20 5 19.7761 5 19.5C5 16.3603 7.97254 14 12 14C16.0275 14 19 16.3603 19 19.5C19 19.7761 18.7761 20 18.5 20C18.2239 20 18 19.7761 18 19.5C18 17.1169 15.7045 15 12 15Z"
  })));
}

const ForwardRef$5 = /*#__PURE__*/React.forwardRef(SvgUser);

var UserOutline = forwardRef((props, ref) => jsx(ForwardRef$5, Object.assign({
  ref: ref
}, props)));

var _path$4;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgWarning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM13 11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11V8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8L13 11ZM13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15Z"
  })));
}

const ForwardRef$4 = /*#__PURE__*/React.forwardRef(SvgWarning);

var WarningSolid = forwardRef((props, ref) => jsx(ForwardRef$4, Object.assign({
  ref: ref
}, props)));

var _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgWatchlist$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30891 4.61849L7.20163 8.20175H3.59126C3.39995 8.20175 3.31782 8.44455 3.46985 8.56068L6.39919 10.7985L5.28555 14.4023C5.22806 14.5883 5.44331 14.7385 5.59805 14.6203L8.5 12.4034L11.4019 14.6203C11.5567 14.7385 11.7719 14.5883 11.7144 14.4023L10.6008 10.7985L13.5302 8.56069C13.6822 8.44455 13.6 8.20175 13.4087 8.20175H9.79837L8.69108 4.61849C8.63301 4.43056 8.36699 4.43056 8.30891 4.61849ZM2.86278 9.35534L5.23782 11.1697L4.33013 14.1071C3.98519 15.2233 5.27668 16.1242 6.20511 15.4149L8.5 13.6618L10.7949 15.4149C11.7233 16.1242 13.0148 15.2233 12.6699 14.1071L11.7622 11.1697L14.1372 9.35534C15.0493 8.65853 14.5566 7.20175 13.4087 7.20175H10.536L9.64651 4.32325C9.29805 3.19563 7.70194 3.19564 7.35349 4.32325L6.46398 7.20175H3.59126C2.44342 7.20175 1.95064 8.65853 2.86278 9.35534ZM13.5 4C13.2239 4 13 4.22386 13 4.5C13 4.77614 13.2239 5 13.5 5H19.5C19.7761 5 20 4.77614 20 4.5C20 4.22386 19.7761 4 19.5 4H13.5ZM16.5 9C16.2239 9 16 9.22386 16 9.5C16 9.77614 16.2239 10 16.5 10H19.5C19.7761 10 20 9.77614 20 9.5C20 9.22386 19.7761 9 19.5 9H16.5ZM15 14.5C15 14.2239 15.2239 14 15.5 14H19.5C19.7761 14 20 14.2239 20 14.5C20 14.7761 19.7761 15 19.5 15H15.5C15.2239 15 15 14.7761 15 14.5ZM4.5 19C4.22386 19 4 19.2239 4 19.5C4 19.7761 4.22386 20 4.5 20H19.5C19.7761 20 20 19.7761 20 19.5C20 19.2239 19.7761 19 19.5 19H4.5Z"
  })));
}

const ForwardRef$3 = /*#__PURE__*/React.forwardRef(SvgWatchlist$1);

var WatchlistOutline = forwardRef((props, ref) => jsx(ForwardRef$3, Object.assign({
  ref: ref
}, props)));

var _path$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgWatchlist(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86254 9.35534L5.23758 11.1697L4.32989 14.1071C3.98495 15.2233 5.27644 16.1242 6.20487 15.4149L8.49975 13.6618L10.7946 15.4149C11.7231 16.1242 13.0146 15.2233 12.6696 14.1071L11.7619 11.1697L14.137 9.35534C15.0491 8.65853 14.5563 7.20175 13.4085 7.20175H10.5358L9.64626 4.32325C9.29781 3.19563 7.7017 3.19564 7.35325 4.32325L6.46374 7.20175H3.59101C2.44318 7.20175 1.9504 8.65853 2.86254 9.35534ZM13.4998 4C13.2236 4 12.9998 4.22386 12.9998 4.5C12.9998 4.77614 13.2236 5 13.4998 5H19.4998C19.7759 5 19.9998 4.77614 19.9998 4.5C19.9998 4.22386 19.7759 4 19.4998 4H13.4998ZM16.4998 9C16.2236 9 15.9998 9.22386 15.9998 9.5C15.9998 9.77614 16.2236 10 16.4998 10H19.4998C19.7759 10 19.9998 9.77614 19.9998 9.5C19.9998 9.22386 19.7759 9 19.4998 9H16.4998ZM14.9998 14.5C14.9998 14.2239 15.2236 14 15.4998 14H19.4998C19.7759 14 19.9998 14.2239 19.9998 14.5C19.9998 14.7761 19.7759 15 19.4998 15H15.4998C15.2236 15 14.9998 14.7761 14.9998 14.5ZM4.49976 19C4.22361 19 3.99976 19.2239 3.99976 19.5C3.99976 19.7761 4.22361 20 4.49976 20H19.4998C19.7759 20 19.9998 19.7761 19.9998 19.5C19.9998 19.2239 19.7759 19 19.4998 19H4.49976Z"
  })));
}

const ForwardRef$2 = /*#__PURE__*/React.forwardRef(SvgWatchlist);

var WatchlistSolid = forwardRef((props, ref) => jsx(ForwardRef$2, Object.assign({
  ref: ref
}, props)));

var _path$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgWatchlistStar$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3997 10.4935L12.0001 6.21582L10.6004 10.4935L6.09517 10.4935L9.73999 13.1232L8.34319 17.3922L12.0001 14.7538L15.6569 17.3922L14.2601 13.1232L17.9049 10.4935H13.3997ZM9.87544 9.49352H6.09517C5.12476 9.49352 4.72311 10.7367 5.51007 11.3045L8.56236 13.5067L7.39277 17.0813C7.09173 18.0013 8.14321 18.7696 8.92829 18.2032L12.0001 15.9869L15.0718 18.2032C15.8569 18.7696 16.9084 18.0013 16.6073 17.0813L15.4377 13.5067L18.49 11.3045C19.277 10.7367 18.8753 9.49352 17.9049 9.49352H14.1247L12.9505 5.90485C12.6499 4.98614 11.3502 4.98614 11.0496 5.90485L9.87544 9.49352Z"
  })));
}

const ForwardRef$1 = /*#__PURE__*/React.forwardRef(SvgWatchlistStar$1);

var WatchlistStarOutline = forwardRef((props, ref) => jsx(ForwardRef$1, Object.assign({
  ref: ref
}, props)));

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgWatchlistStar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0496 5.90475C11.3502 4.98605 12.6498 4.98605 12.9504 5.90475L14.1246 9.49342H17.9049C18.8753 9.49342 19.2769 10.7366 18.49 11.3044L15.4377 13.5066L16.6073 17.0812C16.9083 18.0012 15.8568 18.7695 15.0718 18.2031L12 15.9868L8.92824 18.2031C8.14316 18.7695 7.09168 18.0012 7.39272 17.0812L8.56231 13.5066L5.51002 11.3044C4.72306 10.7366 5.12471 9.49342 6.09512 9.49342H9.87539L11.0496 5.90475Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchlistStar);

var WatchlistStarSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { MoreHorizontalBoldOutline as $, AddToListSolid as A, BinSolid as B, CalendarOutline as C, DangerSolid as D, EditOutline as E, EditSolid as F, ExecutiveOutline as G, ExecutiveSmallOutline as H, ExpandSolid as I, EyeSolid as J, FilterOutline as K, FvOutline as L, FvSolid as M, HeadingTextSolid as N, HomeOutline as O, HomeSolid as P, InfoDescriptionSolid as Q, InformationSolid as R, SuccessSolid as S, ItalicTextSolid as T, LineDownOutline as U, LineUpOutline as V, WarningSolid as W, LinkOutline as X, ListSolid as Y, MarketInsightsOutline as Z, MenuSolid as _, AddToPortfolioOutline as a, MoreHorizontalBoldSolid as a0, MoreHorizontalSolid as a1, MoreVerticalSolid as a2, OpenNewWindowOutline as a3, PlusSolid as a4, PortfolioOutline as a5, PortfolioSolid as a6, QuestionMarkOutline as a7, ResetSolid as a8, RewardSolid as a9, ScreenerOutline as aa, ScreenerSolid as ab, SearchSolid as ac, ShareOutline as ad, SidebarOutline as ae, SmileyNeutralSolid as af, SortingOutline as ag, StatementNegativeSolid as ah, StatementNoDataSolid as ai, StatementPositiveSolid as aj, StatementWarningSolid as ak, StocksOutline as al, StocksSolid as am, SupportSolid as an, TableSolid as ao, TickSolid as ap, TilesSolid as aq, TransferSolid as ar, UserOutline as as, WatchlistOutline as at, WatchlistSolid as au, WatchlistStarOutline as av, WatchlistStarSolid as aw, AngledCollapseSolid as b, AngledExpandSolid as c, AnnouncementOutline as d, ArrowRightSolid as e, ArticleOutline as f, BoardMembersOutline as g, BoldTextSolid as h, BulletListSolid as i, ChartStandOutline as j, CheckSolid as k, ChevronDownSmallSolid as l, ChevronLeftEndSolid as m, ChevronLeftSolid as n, ChevronRightEndSolid as o, ChevronRightSmallSolid as p, ChevronRightSolid as q, CompanyOutline as r, CopyLinkOutline as s, DiscoverOutline as t, DiscoverSolid as u, DownSolid as v, DownloadImageSolid as w, DownloadPdfSolid as x, DownloadReportSolid as y, DownloadXlsSolid as z };
